<div class="mx-3 sm:mx-16 lg:mx-24">

  <div class="flex sticky w-full z-1000 bg-white generic-stepper-bar" style="align-items: flex-end; height: auto; min-height: 43px;">

    <!-- Tabs container -->
    <div class="generic-tabs-container">

      <button
        *ngFor="let tab of tabs; let i = index"
        (click)="i <= activeTab && (activeTab = i)"
        [disabled]="i > activeTab"
        class="step-tab"
        [ngClass]="{
          'step-tab-1': i === 0,
          'step-tab-2': i === 1,
          'step-tab-3': i === 2,
          'active': i === activeTab,
          'completed': i < activeTab,
          'disabled': i > activeTab
        }"
        [ngStyle]="getTabColorStyle(i)"
      >
        <!-- Content -->
        <span style="position:relative; z-index:2; display:flex; align-items:center; gap:8px;">

          <!-- Step Circle — colours driven by formThemes config -->
          <span [ngStyle]="getStepperCircleStyle(i)">
            <ng-container *ngIf="i < activeTab"><span [ngStyle]="getTickColor(i)">✓</span></ng-container>
            <ng-container *ngIf="i >= activeTab">{{ i + 1 }}</ng-container>
          </span>

          <!-- Title -->
          <span>{{ lang[tab.langKey] || tab.title }}</span>

        </span>
      </button>

    </div>

    <!-- Cart — hidden on tab 0.
         For NHLAA (corp): show only when user has selected a plan (planAmount > 0),
         because company-paid plans cost $0 and shouldn't force the cart to appear.
         For GIG/Viking: always shown on tab 1+ as before. -->
    <div *ngIf="activeTab >= 1 && ((employeeDealingPlansarr.length>0 || payrollCCplansarr.length>0 || iafgplansCheck.length>0) || +planAmount > 0)"
         style="display:flex; align-items:center; gap:8px; padding:4px 12px; flex-shrink:0;">
      <img src="../../assets/img/cart.png" alt="cart" style="width:28px; height:28px; object-fit:contain;" />
      <p style="font-size:10px; line-height:1.5; margin:0;">
        {{ lang.Monthly_premium }}<br>{{ lang.Taxes_included }}<br>
        <strong *ngIf="+planAmount > 0">${{ +planAmount | number:'1.2-2' }}</strong>
      </p>
    </div>



     <div class="grid grid-cols-1 sticky w-full sm:grid-cols-4" *ngIf="false">
      <button *ngFor="let tab of tabs; let i = index" (click)="setActiveTab(i)" [ngClass]="getTabClass(i)"
        [disabled]="activeTab !== i"
        class="flex items-center text-center   justify-center mt-2 h-16 w-full rounded-tr-full rounded-bl-lg  p-0.5 "
        [class.text-green-700]="activeTab === i" [class.bg-green-200]="activeTab === i"
        [class.bg-gray-200]="activeTab <i" [class.border-transparent]="activeTab !== i">
        {{ lang[tab.langKey] || tab.title }}
        <!-- font-bold -->
        <!-- [disabled]="activeTab !== i"     -->
        <!-- [class.animate-pulse]="activeTab === i" -->
        @if(activeTab === i){&nbsp;&nbsp;
        <span class="relative flex justify-end h-12 w-12 mb-16">
          @if(activeTab !== i){
          <svg class="h-28 w-14 text-blue-900" viewBox="0 0 23 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>

          }
          <!-- <div id="arrowAnim" class="col-span-1">
          <div class="arrowSliding">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay1">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay2">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay3">
            <div class="arrow"></div>
          </div>
        </div> -->
          <!-- <img
          class="h-20 w-20 mb-15"
          src="./../../assets/img/image.gif"
        /> -->

          <!-- <span
          class="animate-ping absolute inline-flex h-8 w-8 mt-9 rounded-full bg-green-400 opacity-75"
        ></span> -->
          <!-- <span class="relative inline-flex rounded-full h-4 w-4 bg-green-700"></span> -->
        </span>
        }
      </button>
      <button class="flex items-center justify-center h-16 w-full mt-[-5px]">
        <div class="h-16 w-16">
          <img src="../../assets/img/cart.png" alt="" />
        </div>
        <p class="text-small leading-6">
          {{ lang.Monthly_premium }} <br />{{ lang.Taxes_included }}<br>

          @if(planAmount && planAmount.length>0){
          <strong>${{ planAmount | number: "1.2-2" }}</strong>
          }
        </p>
      </button>
    </div>

  </div>
  <div class="generic-step-line" [ngStyle]="getProgressLineStyle()"></div>

  <!-- NHLAA gets a viewport-aware height (see .nhlaa-scroll-area); every other form type keeps
       the original fixed 100vh calculation so nothing else changes. -->
  <div class="linescrollbar px-2 sm:px-4"
       [ngClass]="currFormType === 'nhlaa' ? 'nhlaa-scroll-area' : ''"
       [ngStyle]="currFormType === 'nhlaa' ? {} : { 'height': 'calc(100vh - 260px)', 'overflow-y': 'auto' }">
    @if(activeTab === 0)
    {

<form autocomplete="off" [formGroup]="userForm" (ngSubmit)="onSubmit(userForm.value, 0)">
  <!-- 4-col grid for NHLAA/CORP layout; 5-col for GIG/Viking -->
  <!-- viking: 2 columns below md (its field spans are capped to match by toVikingResponsiveSpan),
       5 from md up as before. Other form types keep their original grids. -->
  <div [ngClass]="currFormType === 'nhlaa' ? 'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2'
       : currFormType === 'viking' ? 'grid grid-cols-2 md:grid-cols-5 gap-2'
       : 'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-2'">



    <ng-container *ngFor="let sectionKey of activeSections">


    <ng-container>

    <!-- HR divider: always in parent grid as col-span-full. -->
    <ng-container *ngIf="showDividerBefore(sectionKey) && sectionKey != 'prior_group_coverage_confirmation' && isSectionVisible(sectionKey)">
      <div class="col-span-full w-full">
        <hr class="h-px bg-indigo-700 border-y-2 dark:bg-gray-700" />
      </div>
    </ng-container>

    <!-- personal_information address sub-label: stays in parent grid -->
    <ng-container *ngIf="sectionKey === 'personal_information'">
      <ng-container *ngIf="activeFields['personal_information']?.['address_line_1']">
        <div class="col-span-full w-full lg:w-1/2 underline decoration-indigo-700 font-bold"
              [style.order]="5.5">
        </div>
      </ng-container>
    </ng-container>

    <!-- NHLAA section wrappers:
         phr_questions  → col-span-full, own 4-col sub-grid so working_hours|hasPHR are
                          always side-by-side regardless of parent grid flow.
         spouse_information → col-start-1 col-span-2, own 2-col sub-grid (left half).
         children_information → col-start-3 col-span-2, own 2-col sub-grid (right half).
         All other sections → display:contents (children participate directly in parent grid). -->
    <div [ngClass]="((currFormType === 'nhlaa' || currFormType === 'corp') && sectionKey === 'personal_information')
         ? 'col-span-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2'
         : ((currFormType === 'gig' || currFormType === 'corp') && sectionKey === 'phr_questions')
         ? 'col-span-full grid grid-cols-1 md:grid-cols-4 gap-4 phr-section-wrapper'
         : (currFormType === 'nhlaa' && sectionKey === 'phr_questions')
         ? 'col-span-full grid grid-cols-1 sm:grid-cols-5 md:grid-cols-10 gap-4 phr-section-wrapper'
         : (currFormType === 'nhlaa' && sectionKey === 'spouse_information')
         ? 'col-span-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2'
         : (currFormType === 'corp' && sectionKey === 'spouse_information')
         ? 'col-span-full grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-2'
         : 'contents'">

    <ng-container *ngIf="getSectionLabel(sectionKey) && isSectionVisible(sectionKey)">
      <div class="col-span-full w-full underline decoration-indigo-700 font-bold labeling">
        {{ getSectionLabel(sectionKey) }}
      </div>
    </ng-container>

    <ng-container *ngFor="let fieldKey of getSectionFieldKeys(sectionKey)">

      <ng-container *ngIf="fieldKey === 'first_name' && currFormType === 'nhlaa'">
        <div class="col-span-full w-full underline decoration-indigo-700 font-bold labeling" style="font-weight: 600;">
          {{ lang.Player_Information || 'Player Information' }}
        </div>
      </ng-container>

      <ng-container *ngIf="fieldKey === 'address_line_1'">
        <div class="col-span-full w-full lg:w-1/2 underline decoration-indigo-700 font-bold">
          {{ lang.Home_Mailing_Address }}
        </div>
      </ng-container>



      <ng-container *ngIf="isFieldVisible(activeFields[sectionKey][fieldKey]) && (fieldKey !== 'spouse_same_address' || isMemberAddressFilled()) && !isInlineAddToPlan(fieldKey)">

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'blank'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)"></div>
        </ng-container>

        <!-- NHLAA Player ID: static "01999" prefix + zero padded 5 digit box (display only, control keeps the raw digits) -->
        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'text' && isNhlaaMemberIdField(fieldKey)">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <div class="nhlaa-id-group"
                 [class.is-focused]="nhlaaMemberIdFocused"
                 [class.is-disabled]="isFieldDisabled(activeFields[sectionKey][fieldKey])">
              <span class="nhlaa-id-prefix">01999</span>
              <input
                type="text"
                inputmode="numeric"
                autocomplete="off"
                class="nhlaa-id-input"
                [id]="activeFields[sectionKey][fieldKey].field"
                [value]="nhlaaMemberIdDisplay"
                [placeholder]="nhlaaMemberIdPlaceholder"
                [attr.disabled]="isFieldDisabled(activeFields[sectionKey][fieldKey]) ? true : null"
                maxlength="5"
                (keydown)="onNhlaaMemberIdKeydown($event)"
                (paste)="onNhlaaMemberIdPaste($event)"
                (input)="onNhlaaMemberIdInput($event)"
                (focus)="nhlaaMemberIdFocused = true"
                (blur)="onNhlaaMemberIdBlur()"
              />
            </div>
            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'text' && !isNhlaaMemberIdField(fieldKey)">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <input
              type="text"
              class="form-control checking-field"
              [id]="activeFields[sectionKey][fieldKey].field"
              [placeholder]="lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].placeholder"
              [formControlName]="getFormControlName(fieldKey)"
              [attr.disabled]="isFieldDisabled(activeFields[sectionKey][fieldKey]) ? true : null"
              [attr.maxlength]="isDigitsOnlyField(fieldKey) ? 5 : isAlphaField(fieldKey) ? 40 : null"
              [attr.minlength]="isAlphaField(fieldKey) ? 1 : null"
              (keypress)="isDigitsOnlyField(fieldKey) ? digitsOnly($event) : isAlphaField(fieldKey) ? alphabatesOnly($event) : null"
              (paste)="isDigitsOnlyField(fieldKey) ? $event.preventDefault() : null"
              (input)="isUppercaseField(fieldKey) ? changeTextToUppercase(getFormControlName(fieldKey), $event) : null"
              (blur)="fieldKey === 'employer_phone_or_email' ? formatEmployerPhoneOrEmail() : null"
            />
            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
            <div *ngIf="fieldKey === 'postal_code' && invalidPostalCodeForProvince" class="invalid text-red-500">
              {{ lang.Please_enter_valid_postal_code }}
            </div>
            <div *ngIf="fieldKey === 'spouse_postal_code' && invalidSpousePostalCodeForProvince" class="invalid text-red-500">
              {{ lang.Please_enter_valid_postal_code }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'email'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <input
              type="email"
              class="form-control checking-field"
              [id]="activeFields[sectionKey][fieldKey].field"
              [placeholder]="lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].placeholder"
              [formControlName]="getFormControlName(fieldKey)"
            />
            <div *ngIf="f[getFormControlName(fieldKey)]?.errors && f[getFormControlName(fieldKey)]?.touched" class="invalid text-red-500">
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['required']">{{ lang[activeFields[sectionKey][fieldKey].error] || activeFields[sectionKey][fieldKey].error }}</div>
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['pattern']">{{ lang[activeFields[sectionKey][fieldKey].error1] || activeFields[sectionKey][fieldKey].error1 }}</div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'phone'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <input
              type="tel"
              class="form-control checking-field"
              [id]="activeFields[sectionKey][fieldKey].field"
              placeholder="+1 (123) 456-7890"
              [formControlName]="getFormControlName(fieldKey)"
              (change)="phoneFormat($event)"
            />
            <div *ngIf="f[getFormControlName(fieldKey)]?.errors && f[getFormControlName(fieldKey)]?.touched" class="invalid text-red-500">
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['required']">{{ lang[activeFields[sectionKey][fieldKey].error] }}</div>
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['minlength'] || f[getFormControlName(fieldKey)]?.errors?.['maxlength']">{{ lang[activeFields[sectionKey][fieldKey].error1] }}</div>
            </div>
          </div>
        </ng-container>


         <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'blank'">
             <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)"></div>
         </ng-container>
        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'number'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)" [ngStyle]="getFieldGridStyle(sectionKey, fieldKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <input
              type="number"
              class="form-control checking-field"
              [id]="activeFields[sectionKey][fieldKey].field"
              [placeholder]="activeFields[sectionKey][fieldKey].placeholder || ''"
              [formControlName]="getFormControlName(fieldKey)"
              [attr.value]="activeFields[sectionKey][fieldKey].defaultvalue ?? null"
            />
            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'dropdown' || activeFields[sectionKey][fieldKey].type === 'select'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)" [ngStyle]="getFieldGridStyle(sectionKey, fieldKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <select
              class="form-control"
              [id]="activeFields[sectionKey][fieldKey].field"
              [formControlName]="getFormControlName(fieldKey)"
              (change)="onDropdownChange(fieldKey, $event)"
            >
              <option value="">{{ lang.Select }}</option>

              <ng-container *ngIf="fieldKey === 'plan_enrollment_date'">
                <option *ngFor="let name of configplanEnrollmentDateFull" [value]="name">{{ name }}</option>
              </ng-container>

              <ng-container *ngIf="fieldKey === 'province'">
                <option *ngFor="let p of configprovinceres" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

                 <ng-container *ngIf="fieldKey === 'spouse_province'">
                <option *ngFor="let p of configprovinceres" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

              <ng-container *ngIf="fieldKey === 'spouse_province_of_coverage'">
                <option *ngFor="let p of configprovinceres" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

              <ng-container *ngIf="fieldKey === 'province_of_coverage'">
                <option *ngFor="let p of configprovinceres" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

              <!-- Province of Employment uses the working-province list from the API -->
              <ng-container *ngIf="fieldKey === 'provience_of_employment'">
                <option *ngFor="let p of (configpworkingrovinceres || configprovinceres)" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

              <ng-container *ngIf="fieldKey === 'province_of_residence'">
                <option *ngFor="let p of (configpworkingrovinceres || configprovinceres)" [value]="p.shortName">{{ p.shortName }}</option>
              </ng-container>

              <ng-container *ngIf="fieldKey !== 'plan_enrollment_date' && fieldKey !== 'province' && fieldKey !== 'province_of_residence'  && fieldKey != 'spouse_province' && fieldKey !== 'spouse_province_of_coverage' && fieldKey !== 'province_of_coverage' && fieldKey !== 'provience_of_employment'">
                <option *ngFor="let opt of activeFields[sectionKey][fieldKey].options" [value]="opt.value">
                  {{ lang[opt.label] || opt.label }}
                </option>
              </ng-container>
            </select>

            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'datepciker'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)" [ngStyle]="getFieldGridStyle(sectionKey, fieldKey)">
            <label [for]="activeFields[sectionKey][fieldKey].field" class="labeling">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <input
              type="text"
              (paste)="(false)"
              [id]="activeFields[sectionKey][fieldKey].field"
              class="form-control"
              [formControlName]="getFormControlName(fieldKey)"
              [minDate]="getDateMin(fieldKey)"
              [maxDate]="getDateMax(fieldKey)"
              #dp
              [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY', showWeekNumbers: false, containerClass: currFormType === 'nhlaa' ? 'theme-green nhlaa-datepicker' : 'theme-green' }"
              placeholder="MM-DD-YYYY"
              bsDatepicker
              (blur)="onDateBlur(fieldKey, $event)"
              (input)="onDateInput(fieldKey, $event)"
              (keypress)="numbersOnly($event)"
            />
            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
            <div *ngIf="activeFields[sectionKey][fieldKey].age_check && memberAgeOverError" class="invalid text-red-500">
              {{ memberAgeOverError }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'radio'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)" [ngStyle]="getFieldGridStyle(sectionKey, fieldKey)">
            <label class="labeling lineheight">
              {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
              <span *ngIf="isRequired(activeFields[sectionKey][fieldKey])" style="color:red">*</span>
            </label>
            <div class="flex gap-[10px] items-center" style="min-height: 2.5rem;">
            <div *ngFor="let opt of activeFields[sectionKey][fieldKey].options" class="flex items-center space-x-2">
              <input
                type="radio"
                [id]="getFormControlName(fieldKey) + '_' + opt.value"
                [formControlName]="getFormControlName(fieldKey)"
                [value]="opt.value"
                class="form-radio text-blue-600"
                [attr.disabled]="getRadioDisabled(fieldKey) ? true : null"
                (change)="onRadioChange(fieldKey, $event)"
              />
              <label [for]="getFormControlName(fieldKey) + '_' + opt.value" class="labeling">
                {{ lang[opt.label] || opt.label }}
              </label>
            </div>
            <!-- NHLAA: Add button inline next to radio options to save vertical space -->
            <ng-container *ngIf="currFormType === 'nhlaa' && fieldKey === 'has_child' && userForm.get(getFormControlName(fieldKey))?.value === 'yes'">
              <button
                type="button"
                class="w-28 h-10 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 transition duration-700 ease-in-out hover:bg-white self-center"
                (click)="childAddFun()"
                style="margin-bottom: 6px;"
              >{{ lang.Add }}</button>
            </ng-container>

            <!-- Viking: spouse "Add to plan" sits inline right after Yes/No — as its own grid
                 cell it was landing under the name fields and members kept missing it.
                 Rendered here instead of in the checkbox block (see isInlineAddToPlan). -->
            <ng-container *ngIf="fieldKey === 'has_spouse'
                                 && isInlineAddToPlan('spouse_add_to_plan')
                                 && activeFields[sectionKey]?.['spouse_add_to_plan']
                                 && userForm.get(getFormControlName(fieldKey))?.value === 'yes'">
              <div class="checkbox-row ml-4" style="margin-bottom: 5px;">
                <input type="checkbox" class="shrink-0"
                       [id]="activeFields[sectionKey]['spouse_add_to_plan'].field"
                       [formControlName]="getFormControlName('spouse_add_to_plan')" />
                <label class="labeling mb-0 font-semibold whitespace-nowrap"
                       [for]="activeFields[sectionKey]['spouse_add_to_plan'].field">
                  {{ lang[activeFields[sectionKey]['spouse_add_to_plan'].language_token] || activeFields[sectionKey]['spouse_add_to_plan'].label }}
                </label>
              </div>
            </ng-container>
            </div>

            <div *ngIf="f[getFormControlName(fieldKey)]?.errors && f[getFormControlName(fieldKey)]?.touched" class="invalid text-red-500">
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['required']">{{ lang[activeFields[sectionKey][fieldKey].error] || activeFields[sectionKey][fieldKey].error }}</div>
              <div *ngIf="f[getFormControlName(fieldKey)]?.errors?.['invalidhoursselection']">{{ lang[activeFields[sectionKey][fieldKey].error] || activeFields[sectionKey][fieldKey].error1 }}</div>
            </div>

            <!-- <ng-container *ngIf="currFormType !== 'nhlaa' && (fieldKey === 'working_hours' || fieldKey === 'working_hours_30') && userForm.get(getFormControlName(fieldKey))?.value === 'yes'">
              <div class="col-span-1 w-1/2 mt-2">
                <label for="hours_per_week" class="labeling">
                  {{ lang.Hours_Per_week }}<span style="color:red">*</span>
                </label>
                <input
                  class="form-control checking-field"
                  type="number"
                  id="hours_per_week"
                  [placeholder]="lang.Hours_Per_week"
                  value="40"
                  formControlName="hours_per_week"
                  maxlength="2"
                  min="20"
                  max="80"
                />
                <div *ngIf="f['hours_per_week']?.errors && f['hours_per_week']?.touched" class="invalid text-red-500">
                  <div *ngIf="f['hours_per_week']?.errors?.['required']">{{ lang.Please_select_working_hours_per_week }}</div>
                  <div *ngIf="f['hours_per_week']?.errors?.['mininvalidhours']">{{ lang.Hours_Per_week_should_be_more_than_20 }}</div>
                  <div *ngIf="f['hours_per_week']?.errors?.['maxinvalidhours']">{{ lang.Hours_Per_week_should_be_less_than_80 }}</div>
                </div>
              </div>
            </ng-container> -->

            <ng-container *ngIf="fieldKey === 'has_child' && userForm.get(getFormControlName(fieldKey))?.value === 'yes'">
              <div class="flex gap-[7px] items-end" *ngIf="currFormType !== 'nhlaa'">
                <div class="w-1/2">
                  <label for="no_of_children" class="labeling">
                    {{ lang.No_of_Children }}<span style="color:red">*</span>
                  </label>
                  <input
                    class="form-control"
                    type="number"
                    id="no_of_children"
                    value="1"
                    formControlName="no_of_children"
                    onkeypress="return /^[0-9]+$/.test(event.key)"
                    min="1"
                  />
                </div>
                <div class="col-span-1">
                  <button
                  *ngIf="currFormType == 'nhlaa'"
                    type="button"
                    class="w-28 h-12 mt-8 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 transition duration-700 ease-in-out hover:bg-white"
                    (click)="childAddFun()"
                    style="margin-bottom: 6px;"
                  >{{ lang.Add }}</button>

                <button
                  *ngIf="currFormType != 'nhlaa'"
                    type="button"
                    class="w-28 h-12 mt-8 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 transition duration-700 ease-in-out hover:bg-white"
                    (click)="childAddFun()"
                  >{{ lang.Add }}</button>
                </div>
              </div>

              <div *ngIf="childTableRowsLength === 0" class="invalid text-red-500">
                {{ lang.Please_add_at_least_one_child }}
              </div>

              <div *ngIf="childTableRowsLength > 0" class="col-span-1 table-responsive mt-2">
                <table class="table" style="font-size:14px">
                  <thead>
                    <tr class="trbottomsolid">
                      <th class="bgColor-tr">{{ lang.S_no }}</th>
                      <th class="bgColor-tr">{{ lang.First_Name }}</th>
                      <th class="bgColor-tr">{{ lang.last_name }}</th>
                      <th class="bgColor-tr">{{ lang.Gender }}</th>
                      <th class="bgColor-tr">{{ lang.Date_of_Birth }}</th>
                      <th class="bgColor-tr">{{ lang.Action }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let childData of childInfoAddDataArray; let i = index">
                      <td class="thBottomNone">{{ i + 1 }}</td>
                      <td class="thBottomNone text-capitalize">{{ childData.firstName }}</td>
                      <td class="thBottomNone text-capitalize">{{ childData.lastName }}</td>
                      <td class="thBottomNone">{{ childData.gender }}</td>
                      <td class="thBottomNone">{{ childData.date_of_birth | displayDate }}</td>
                      <td class="thBottomNone text-center inline-flex items-center">
                        <svg class="h-10 w-10 text-green-600 cursor-pointer" (click)="EditChild(i)"
                          viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                          <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                          <line x1="16" y1="5" x2="19" y2="8" />
                        </svg>
                        <svg class="h-9 w-9 text-red-600 cursor-pointer" (click)="DeleteChild(i)"
                          viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                          stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <rect x="3" y="4" width="18" height="4" rx="2" />
                          <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                          <line x1="10" y1="12" x2="14" y2="12" />
                        </svg>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>

          </div>
        </ng-container>

        <ng-container *ngIf="activeFields[sectionKey][fieldKey].type === 'checkbox'">
          <div [ngClass]="getFieldColSpan(fieldKey, sectionKey)">

            <!-- Terms & Conditions -->
            <ng-container *ngIf="fieldKey === 'terms_and_conditions'">
              <div class="checkbox-row">
                <input type="checkbox" [value]="true" [formControlName]="getFormControlName(fieldKey)" [id]="activeFields[sectionKey][fieldKey].field" class="shrink-0" />
                <label class="termsandconditions cursor-pointer labeling mb-0" [for]="activeFields[sectionKey][fieldKey].field">
                  {{ lang.I_have_read_and_agree_to_the }}
                  <span class="termsandconditionspara" (click)="termandconditions()">
                    <span class="termsandconditionslink" style="color:#007bff">{{ lang.Terms_Conditions }}</span>
                  </span>
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="fieldKey === 'advisor_disclosuer'">
              <div class="checkbox-row">
                <input type="checkbox" [value]="true" [formControlName]="getFormControlName(fieldKey)" [id]="activeFields[sectionKey][fieldKey].field" class="shrink-0" />
                <label class="Advisor cursor-pointer labeling mb-0" [for]="activeFields[sectionKey][fieldKey].field">
                  {{ lang.I_have_read_the }}
                  <span (click)="advisorDisclousre()">
                    <span class="advisordisclosure" style="color:#007bff">{{ lang.Advisor_Disclosure }}</span>
                  </span>
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="fieldKey === 'spouse_same_address'">
              <div class="checkbox-row">
                <input (change)="onSpouseSameAddressChange($event)" type="checkbox" [value]="true" [formControlName]="getFormControlName(fieldKey)" [id]="activeFields[sectionKey][fieldKey].field" class="shrink-0" />
                <label class="Advisor cursor-pointer labeling mb-0" [for]="activeFields[sectionKey][fieldKey].field">
                  {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="fieldKey !== 'terms_and_conditions' && fieldKey !== 'advisor_disclosuer' && fieldKey !== 'spouse_same_address'">
              <div class="checkbox-row">
                <input type="checkbox" [formControlName]="getFormControlName(fieldKey)" [id]="activeFields[sectionKey][fieldKey].field" class="shrink-0" />
                <label class="labeling mb-0"
                  [class.font-semibold]="activeFields[sectionKey][fieldKey].label === 'Add to plan' || activeFields[sectionKey][fieldKey].label === 'Add To Plan'"
                  [for]="activeFields[sectionKey][fieldKey].field">
                  {{ lang[activeFields[sectionKey][fieldKey].language_token] || activeFields[sectionKey][fieldKey].label }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngTemplateOutlet="errorBlock; context: { field: activeFields[sectionKey][fieldKey], key: fieldKey }"></ng-container>
          </div>
        </ng-container>

      </ng-container>

    </ng-container>

    </div><!-- /section wrapper (col-span-2 sub-grid for NHLAA spouse/children; contents for others) -->

    </ng-container>
    </ng-container>

  </div>

  <div class="relative w-full">
    <div class="text-end fixed bottom-10 right-3 sm:right-16 lg:right-24 pointer-events-none">
      <button
        type="submit"
        class="w-36 h-14 mb-1 rounded-full border-2 text-center inline-flex items-center border-indigo-200 bg-indigo-200 p-0.5 transition duration-700 ease-in-out hover:bg-white px-5 py-2.5 me-2 pointer-events-auto"
      >
        {{ lang.Next }}&nbsp;&nbsp;
        <svg class="h-10 w-10 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
    </div>
  </div>
</form>

<ng-template #errorBlock let-field="field" let-key="key">
  <div
    *ngIf="f[getFormControlName(key)]?.errors && f[getFormControlName(key)]?.touched"
    class="invalid text-red-500"
  >
    <div *ngIf="f[getFormControlName(key)]?.errors?.['required']">{{ lang[field.error] || field.error }}</div>
    <div *ngIf="f[getFormControlName(key)]?.errors?.['minlength'] && field.error1">{{ lang[field.error1] || field.error1 }}</div>
    <div *ngIf="f[getFormControlName(key)]?.errors?.['pattern'] && field.error1">{{ lang[field.error1] || field.error1 }}</div>
  </div>
</ng-template>



    }
    @if(activeTab === 1){
    <div class="sticky top-0 bg-white z-10 pb-1">
      @if(currFormType === 'nhlaa'){
        <div class="firstname" style="font-size: 17px; padding-top: 10px;padding-bottom: 10px;">{{ completeapplicantinfo }}</div>
      }
      @if(currFormType !== 'nhlaa'){
        <div class="firstname" style="font-size: 17px;">{{lang.Hi}} &nbsp;{{ applicantfirstname }}, {{ completeapplicantinfo }}</div>
      }
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         CORP (NHLAA) plan tiles moved to <app-corp-plans-enrollment>.
         That component is rendered for currForm === 'CORP' (see below tab 2 block).
         ═══════════════════════════════════════════════════════════════════════ -->
    @if(false && currFormType === 'nhlaa') {<!-- disabled: handled by corp-plans-enrollment -->
    <div class="plansscreen pb-20">
      @for (package of corpPlansData; track package) {
        <div class="text-black text-center text-[18px] font-bold mt-4 mb-4"
             *ngIf="package?.groups?.length >= 1">
          {{ package.name }}
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border rounded-md w-full gap-4 plansscreen">
          @for (group of package.groups; track group; let i = $index) {
            @for (plan of group.plans; track plan; let i = $index) {
              @for (product of plan.productAddonssNames; track product; let j = $index) {

                <!-- Corp plan tile card -->
                <div class="shadow-lg px-2 rounded-lg w-82" [style.background-color]="
                    plan.isBundle == false
                      ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor
                      : group?.backgroundColor">

                  <!-- Tile header: category label + plan name -->
                  <div class="text-center text-white font-bold h-14 mt-1">
                    @if(group.categorization.paidByCompany == 1) {
                      <h6>{{ lang.Company_Paid || 'Company Paid' }}</h6>
                    }
                    @if(group.categorization.coveredByCompany == 1) {
                      <h6>{{ lang.Upgrade_To || 'Upgrade To' }}</h6>
                    }
                    @if(group.categorization.paidByEmployee == 1) {
                      <h6>{{ lang.Voluntary_Opt_In || 'Voluntary Opt-In' }}</h6>
                    }
                    <h1 class="text-[16px] mt-2 truncate" title="{{ product }}">{{ product }}</h1>
                  </div>

                  <div class="p-2">
                    <!-- Plan features / description box -->
                    @if(plan.isBundle == true) {
                      <div class="h-96 overflow-y-scroll scrollbar-thin text-center bg-white">
                        @if(group.planLevelFeatures) {
                          @for(features of group.planLevelFeatures; track features) {
                            @if(features?.feature?.name != null) {
                              <div class="plancheck{{ plan.isBundle ? plan.id : 0 }}"
                                   style="background-color: inherit; padding: 4px; border-bottom: 1px solid #ccc; cursor:pointer">
                                <strong>{{ features?.feature?.name }}</strong>
                              </div>
                              <div *ngIf="features.expanded" class="accordion-content">
                                <p [innerHTML]="features.description | safeHtml"></p>
                              </div>
                            } @else {
                              <p class="text-left" style="padding:5px"
                                 [innerHTML]="features.description | safeHtml"></p>
                            }
                          }
                        } @else if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
                          <p class="text-left p-2"
                             [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
                        } @else if(plan?.description != undefined) {
                          <!-- Fallback: show the bundle plan's own description -->
                          <p class="text-left p-2" [innerHTML]="plan?.description | safeHtml"></p>
                        }
                      </div>
                    } @else {
                      <div class="h-96 overflow-y-scroll scrollbar-thin text-center bg-white">
                        @if(plan?.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures) {
                          @for (features of plan.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures;
                                track features) {
                            <div class="plancheck{{ plan.isBundle ? plan.id : plan.productAddonss[product][0].planlevel?.id }}">
                              <strong>{{ features?.feature?.name }}</strong><br />
                              <p [innerHTML]="features.description | safeHtml"></p>
                            </div>
                          }
                        } @else if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
                          <p class="text-left p-2"
                             [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
                        } @else if(plan?.productAddonss[product]?.[0]?.description != undefined) {
                          <!-- Fallback: show addon description when no planLevelFeatures or description2 -->
                          <p class="text-left p-2"
                             [innerHTML]="plan?.productAddonss[product]?.[0]?.description | safeHtml"></p>
                        }
                      </div>
                    }

                    <!-- Coverage options: checkbox + pricing -->
                    @for(coverage of plan.productAddonss[product]; track coverage; let k = $index) {
                      @if(plan.insuranceType != 'LIFE') {
                        <div class="grid grid-cols-2 text-white text-[16px] mt-1"
                             *ngIf="coverage?.display ?? false">
                          <div class="col-span-1">
                            <!-- accent-color overrides the inherited text-white so the tick is visible (black) -->
                            <input type="checkbox"
                              id="corpplancheck_{{ coverage.id }}"
                              class="plancheckbox{{ package.id }} plancv newPlan{{ plan.id }} coverage{{ coverage.planCoverageUI | uppercase }}"
                              style="accent-color: #000; cursor: pointer;"
                              (change)="onCorpCheckboxChange($event, plan, coverage, package, group, k)" />
                            {{ coverage.planCoverageUI }}
                          </div>
                          <div class="col-span-1 text-[12px]">
                            @if(group.categorization.paidByCompany == 1) {
                              <span style="font-size:14px;">
                                {{ lang.You_pay || 'You pay' }} $0.00<small>*</small>
                              </span>
                            }
                            @if(group.categorization.coveredByCompany == 1) {
                              <span style="font-size:14px; float:right">
                                {{ lang.You_pay_through_payroll_deduction || 'You pay (payroll)' }}
                                ${{ coverage.price | number:'1.2-2' }}<small>*</small>
                              </span>
                            }
                            @if(group.categorization.paidByEmployee == 1) {
                              <span style="font-size:14px; float:right">
                                {{ lang.You_pay_through_CC_PAD || 'You pay' }}
                                ${{ coverage.price | number:'1.2-2' }}<small>*</small>
                              </span>
                            }
                          </div>
                        </div>
                      }
                      @if(plan.insuranceType == 'LIFE') {
                        <app-life-insurance-tile
                          [plan]="plan" [product]="product" [k]="k" [coverage]="coverage"
                          [pkg]="package" [group]="group" [allFormData]="allFormData"
                          [lang]="lang" [userForm]="userForm"
                          (checkboxChangePEvent)="onCheckboxChangeP($event.event, $event.planCoverage, $event.category, $event.key1, $event.productAddon)"
                          (radioChangeEvent)="handleRadioChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
                          (rangeChangeEvent)="handleRangeChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)">
                        </app-life-insurance-tile>
                      }
                    }

                    <p class="text-white text-base">
                      *{{ lang.Monthly_applicable_taxes_extra || 'Monthly + applicable taxes extra' }}
                    </p>
                  </div>
                </div>

              }
            }
          }
        </div>
      }
    </div>
    }<!-- /NHLAA corp tiles -->

    <!-- ═══════════════════════════════════════════════════════════════════════
         GIG / Viking plan tiles — existing logic, untouched.
         ═══════════════════════════════════════════════════════════════════════ -->
    @if(currFormType !== 'nhlaa') {
    <div class="plansscreen pb-20">
      @for (package of plansData; track package) {
      <div class="text-black text-center text-[18px] font-bold mt-4 mb-4" *ngIf="package?.groups?.length >= 1">
        {{ package.name }}
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 border rounded-md w-full gap-4"
           [ngClass]="currFormType === 'viking' ? 'md:grid-cols-3' : 'md:grid-cols-3 lg:grid-cols-4'">
        @for (groups of Object.keys(package.groups); track groups;let i = $index)
        { @for (group of package.groups[groups]; track group) { @for (plan of
        group.plans; track plan;let i=$index) {
        @for (product of plan.productAddonssNames;
        track product;let j=$index) {

        <div class="shadow-lg px-3 rounded-lg w-82" [style.background-color]="
          plan.isBundle == false
            ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor
            : group?.backgroundColor
        ">
          <div class="text-center text-white text-[18px] font-bold h-{{heightCheck}} mt-5" style="
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          ">
            {{ product }}
          </div>

          <div class="p-4">
            @if(plan.isBundle==true){
            @if(hidePlanFeatures){
            <div class="h-96 overflow-y-scroll scrollbar-thin text-center bg-white">
              @if(group.planLevelFeatures){
              @for(features of
              group.planLevelFeatures; track features){

              @if(features.productType){

              @if(plan.jsonData.product_type.includes(features.productType)){
              <strong>{{ features?.feature?.name }}</strong> <br />
              <p [innerHTML]="features.description | safeHtml"></p>
              }

              }
              @else{
              <strong>{{ features?.feature?.name }}</strong> <br />
              <p [innerHTML]="features.description | safeHtml"></p>
              }


              }

              } @else {@if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
              <p [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
              }}
            </div>
            }


            }
            @else{
            @if(hidePlanFeatures){
            <div class="h-96 overflow-y-scroll scrollbar-thin text-center bg-white">
              @if(plan?.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures){
              @for (features of
              plan.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures; track
              features){
              @if(features.productType){

              @if(plan.jsonData.product_type.includes(features.productType)){
              <strong>{{ features?.feature?.name }}</strong> <br />
              <p [innerHTML]="features.description | safeHtml"></p>
              }

              }
              @else{
              <strong>{{ features?.feature?.name }}</strong> <br />
              <p [innerHTML]="features.description | safeHtml"></p>
              }
              } }


              @else {@if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
              <p [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
              }}
            </div>
            }


            } @for(coverage of plan.productAddonss[product]; track coverage;let k=$index){
            <div class="h-34 text-white text-[16px]">
              @if(plan.insuranceType!="LIFE"){
              <span class="overflow-ellipsis2" style="float: right; color: white">
                ${{ coverage.price | number : "1.2-2" }}<small>*</small></span>
              }

              <!-- [checked]="checked[plan.productAddonss[product][k].id]"
              [ngModel]="checked[plan.productAddonss[product][k].id]" -->
              @if(plan.insuranceType!="LIFE"){
              <input type="checkbox" #planCheckdetails
                id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                class="plancheckbox{{ package.id }} plancv  newPlan{{plan.id}}  coverage{{coverage.planCoverageUI | uppercase}}"
                attr.data="{{ package.name }}##{{ group.name }}##{{
                plan.planCoverage
              }}##{{
                plan.productAddonss[product][k].calculatedTax.price
              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                plan.frqMonthly
              }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                group.parentId
              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                plan.packageId
              }}##0##{{ plan.planOptions }}##{{
                plan.productAddonss[product][k].id
              }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{ group.disallowedPlanLevels }}"
                (change)="
              onCheckboxChange(
                $event,
                package.allowMultiple,
                plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                plan.planOptions,
                group.parentId,
                package.name,
                group.name,
                plan.planCoverage,
                0,
                0,
                0,
                0,
                $event,
                i,
                j,
                k,
                plan,
                plan.productAddonss[product][k],package,group,coverage.planCoverageUI)">
              {{ coverage.planCoverageUI }}
              }
              @if(plan.insuranceType=="LIFE"){
              <app-life-insurance-tile
                [plan]="plan"
                [product]="product"
                [k]="k"
                [coverage]="coverage"
                [pkg]="package"
                [group]="group"
                [allFormData]="allFormData"
                [lang]="lang"
                [userForm]="userForm"
                (checkboxChangePEvent)="onCheckboxChangeP($event.event, $event.planCoverage, $event.category, $event.key1, $event.productAddon)"
                (radioChangeEvent)="handleRadioChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
                (rangeChangeEvent)="handleRangeChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)"
              ></app-life-insurance-tile>
              }
            </div>
            }

            <!-- <h3 class="font-bold text-xl mb-2">Card Title 1</h3> -->
            <!-- <p class="text-white text-base">
            *{{ lang.monthly_plus_any_applicable_taxes }}
          </p> -->
          </div>
        </div>
        } }
        <!-- <img src="https://via.placeholder.com/400" alt="Card Image" class="w-full h-48 object-cover"> -->
        } }
      </div>
      }
    </div>
    }<!-- /GIG plan tiles -->

    <!-- Nav buttons for GIG plan selection — CORP has its own buttons inside corp-plans-enrollment -->
    @if(currForm !== 'CORP') {
    <div class="relative">

      <!-- Left Button -->
      <button
        class="fixed text-center inline-flex items-center left-3 sm:left-16 lg:left-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
        (click)="gotoPersonalInfoPage()" style="width: 120px;">

        <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        {{ lang.Previous }}
      </button>
      <!-- [disabled]="plansnexttab || cartcheckvalue" -->
      <!-- Right Button -->
      <button [disabled]="plansnexttab || cartcheckvalue"
        class="fixed text-center inline-flex items-center right-3 sm:right-16 lg:right-24 bottom-10 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-4 hover:bg-white"
        (click)="paymentpage(1)">
        {{ lang.Next }}
        &nbsp;
        <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>


      <!-- <button
            type="submit"
            class="w-36 h-14 mb-1 rounded-full border-2 text-center inline-flex items-center border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white px-5 py-2.5 me-2"
          >{{ lang.next }}&nbsp;&nbsp;
          <svg class="h-10 w-10 me-2 text-sky-900"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>


          </button> -->
    </div>
    }<!-- /nav buttons for GIG -->
    <!-- </div> -->

    }

    <!-- ══════════════════════════════════════════════════════════════════════════
         CORP (NHLAA): plan selection (tab 1) + enrollment summary (tab 2) are
         rendered by the dedicated CorpPlansEnrollmentComponent.
         The component's internal @if(activeTab === 1/2) drives what it displays.
         Parent passes userForm, activeTab, lang, and plan data; receives tab
         navigation events back via (tabChangeRequest).
         ══════════════════════════════════════════════════════════════════════════ -->
    @if(currForm === 'CORP') {
    <app-corp-plans-enrollment
      [userForm]="userForm"
      [activeTabFromParent]="activeTab"
      [mainarrayFromParent]="corpPlansData"
      [signupFormConfigurationsOverride]="signupFormConfigurationsOverride"
      [hidePlanCategorization]="hidePlanCategorization"
      [plansTemplate]="plansTemplate"
      [hideCompanyPaidPlans]="hideCompanyPaidPlans"
      (tabChangeRequest)="onCorpTabChange($event)"
      (cartUpdate)="onCorpCartUpdate($event)"
      [coveragesOverride]="coveragesOverride"
      [signupFormOverrides]="signupFormOverrides"
      [currFormType]="currFormType"
      [disableAutoCheckedPlans]="currFormType !== 'nhlaa'"
      [payrolldeduction]="payrolldeduction"
      >
    </app-corp-plans-enrollment>
    }

    @if(activeTab === 2){

    <!-- ═══════════════════════════════════════════════════════════════════
         NHLAA / CORP enrollment summary moved to <app-corp-plans-enrollment>.
         Disabled here — guarded with @if(false) to preserve the HTML for reference.
         ═══════════════════════════════════════════════════════════════════ -->
    @if(false && currFormType === 'nhlaa') {<!-- disabled: handled by corp-plans-enrollment -->
    <div class="col-span-full bg-white text-black mt-3 mx-2 px-2">

      <!-- ── All Selected Plans Summary ── -->
      <h5 class="mb-2"><strong>{{ lang.All_selected_plans_summary || 'All selected plans summary' }}</strong></h5>
      <table class="table table-bordered text-black w-full">
        <thead>
          <tr>
            <th>{{ lang.Plan || 'Plan' }}</th>
            <th>{{ lang.Type || 'Type' }}</th>
            <th class="text-right">{{ lang.Premium || 'Premium' }}</th>
            <th class="text-right">{{ lang.Tax || 'Tax' }}</th>
            <th class="text-right">{{ lang.Total || 'Total' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of finalenrollemntsummary">
            <td>{{ item.planname }}</td>
            <td>{{ item.type }}</td>
            <td class="text-right">${{ item.planPrice | number:'1.2-2' }}</td>
            <td class="text-right">${{ item.tax | number:'1.2-2' }}</td>
            <td class="text-right">${{ item.totalPrice | number:'1.2-2' }}</td>
          </tr>
          <!-- Totals row -->
          <tr style="background-color: #D08000; color: white;">
            <td><strong>{{ lang.Total || 'Total' }}</strong></td>
            <td></td>
            <td class="text-right"><strong>${{ nhlaaAllPremiumTotal | number:'1.2-2' }}</strong></td>
            <td class="text-right"><strong>${{ nhlaaAllTaxTotal | number:'1.2-2' }}</strong></td>
            <td class="text-right"><strong>${{ nhlaaAllTotal | number:'1.2-2' }}</strong></td>
          </tr>
        </tbody>
      </table>

      <br />

      <!-- ── Monthly Payment Summary ── -->
      <table class="table table-bordered text-black w-full">
        <tbody>
          <tr style="background-color: black;">
            <td style="color:white;" colspan="5"><strong>{{ lang.Monthly_Payment_Summary || 'Monthly Payment Summary' }}</strong></td>
          </tr>

          <!-- Company Pays section -->
          <ng-container *ngIf="nhlaaCompanyPaidPlans.length > 0">
            <tr>
              <td colspan="5"><strong>{{ lang.Company_Pays || 'Company Pays' }}</strong></td>
            </tr>
            <tr *ngFor="let item of nhlaaCompanyPaidPlans">
              <td>{{ item.planname }}</td>
              <td>{{ item.type }}</td>
              <td class="text-right">${{ item.planPrice | number:'1.2-2' }}</td>
              <td class="text-right">${{ item.tax | number:'1.2-2' }}</td>
              <td class="text-right"><strong>${{ item.totalPrice | number:'1.2-2' }}</strong></td>
            </tr>
            <tr style="background-color: #D08000; color: white;">
              <td><strong>{{ lang.Total_charge_to_Company || 'Total charge to Company' }}</strong></td>
              <td></td>
              <td class="text-right"><strong>${{ nhlaaCompanyPremiumTotal | number:'1.2-2' }}</strong></td>
              <td class="text-right"><strong>${{ nhlaaCompanyTaxTotal | number:'1.2-2' }}</strong></td>
              <td class="text-right"><strong>${{ nhlaaCompanyTotal | number:'1.2-2' }}</strong></td>
            </tr>
          </ng-container>

          <!-- Employee Pays section (upgrade / voluntary) -->
          <ng-container *ngIf="nhlaaEmployeePlans.length > 0">
            <tr>
              <td colspan="5"><strong>{{ lang.Employee_Pays || 'Employee Pays' }}</strong></td>
            </tr>
            <tr *ngFor="let item of nhlaaEmployeePlans">
              <td>{{ item.planname }}</td>
              <td>{{ item.type }}</td>
              <td class="text-right">${{ item.planPrice | number:'1.2-2' }}</td>
              <td class="text-right">${{ item.tax | number:'1.2-2' }}</td>
              <td class="text-right"><strong>${{ item.totalPrice | number:'1.2-2' }}</strong></td>
            </tr>
          </ng-container>

        </tbody>
      </table>

      <br />

      <!-- ── Confirmation checkbox — company-paid plans ── -->
      <div class="col-span-full">
        <input type="checkbox" name="comanyprovided" value="true"
          (change)="companyPlansConfirmation($event)" />
        &nbsp;<span class="termsandconditions">
          {{ lang.I_confirm_signing_up_for_the_benefits_plan_provided_by_the_company ||
             'I confirm signing up for the benefits plan provided by the company' }}
        </span>
        @if(companyplansCheck) {
          <div class="invalid text-red-500">
            {{ lang.Please_confirm_Company_paid_plans || 'Please confirm Company paid plans' }}
          </div>
        }
      </div>

    </div>
    }<!-- /NHLAA Enrollment Summary -->

    <!-- ── GIG enrollment summary — hidden entirely for CORP (handled by corp-plans-enrollment) ── -->
    <!-- Outer ng-container guards the gigCheck fallthrough: when currForm === 'CORP', neither
         the CORP block NOR the gigCheck template renders. GIG is unaffected. -->
    <ng-container *ngIf="currForm !== 'CORP'">

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3 mx-2">
      <!-- First column -->

      <div class="col-span-1">
        <form [formGroup]="paymentForm" #paymentform2
          action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
          <!-- <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4 p-4 "  > -->

          <div class="col-span-1">
            <input class="form-control" autofocus="autofocus" id="CustomerId" formcontrolname="cutomerId"
              name="CustomerID" type="hidden" value="{{ customerid }}" />
          </div>
          <div class="col-span-1">
            <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
              type="hidden" value="{{ publicapikey }}" />
          </div>

          <div class="col-span-1">
            <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri" type="hidden"
              value="{{ paymentsuccessuri }}" />
          </div>

          <div class="col-span-1">
            <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
              value="{{ paymentUri }}" />
          </div>

          <div class="col-span-1">
            <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true" type="hidden"
              name="MakeDefault" />
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">

            <div class="col-span-3">
              <label for="Email" class="labeling">{{ lang.Email }}<span style="color: red">*</span></label>

              <input class="form-control" id="Email" placeholder={{lang.Email}} type="hidden" name="email"
                [(ngModel)]="paymentemail" [value]="paymentemail" [ngModelOptions]="{standalone: true}" />
              <input class="form-control" id="Email" placeholder={{lang.Email}} type="email" readonly
                [(ngModel)]="paymentemail" formControlName="email" [value]="paymentemail" />


            </div>

            <div class="col-span-3">
              <div>
                <label for="cardnumnber" class="labeling">{{ lang.Payment_Method }}</label>
              </div>
              <div class="flex items-center space-x-2">
                <input type="radio" id="paymentRadioCheck_true" formControlName="paymentRadioCheck" value="PAD"
                  class="form-radio text-blue-600" (click)="paymentmethod($event)" />
                <!-- <label for="true" class="labeling">{{
                  lang.Pre_authorized_Debit
                  }}</label> -->
                <label for="paymentRadioCheck_true" class="labeling" class="labeling">Pre Authorized Debit</label>
              </div>

              <div class="flex items-center space-x-2">
                <input type="radio" id="paymentRadioCheck_false" formControlName="paymentRadioCheck" value="CC"
                  class="form-radio text-blue-600" (click)="paymentmethod($event)" />
                <label for="paymentRadioCheck_false" class="labeling">{{
                  lang.Credit_Card
                  }}</label>
              </div>
            </div>
          </div>

          <!-- ===== Extra Bank Account ng-template (reused in CC & PAD flows) ===== -->
          <ng-template #extraBankSection>
            @if(paymentForm.get('paymentRadioCheck')?.value){
            <div class="col-span-3 border border-indigo-300 rounded-xl p-4 mt-4 bg-white">
              <p class="labeling font-semibold text-base mb-3" style="font-size: 14px;">Claims - Account details for direct deposit</p>

              @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD'){
              <div class="flex flex-wrap gap-6 mb-4">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="extraBankAccountOption" value="same"
                    [(ngModel)]="extraBankAccountOption" [ngModelOptions]="{standalone: true}"
                    (change)="onExtraBankOptionChange('same')" />
                  <span class="labeling">Same bank account as above</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="extraBankAccountOption" value="different"
                    [(ngModel)]="extraBankAccountOption" [ngModelOptions]="{standalone: true}"
                    (change)="onExtraBankOptionChange('different')" />
                  <span class="labeling">Different account</span>
                </label>
              </div>
              }

              @if(extraBankAccountOption !== 'same'){
              <form [formGroup]="extraBankPayForm">

                <!-- Step 1: Bank identifier inputs -->
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div class="col-span-1">
                    <label class="labeling" style="font-size:13px;">Bank Code<span class="text-red-500">*</span></label>
                    <input type="text" class="form-control checking-field"
                      formControlName="bank_number" placeholder="Bank Code (3 digits)" maxlength="3"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                      (input)="updateExtraBankVerifyButton(); saveExtraBankToSession()" />
                    @if(extraBankPayForm.get('bank_number')?.invalid && extraBankSubmitted){
                    <div class="invalid text-red-500  mt-1">Bank Code is required</div>
                    }
                  </div>

                  <div class="col-span-1">
                    <label class="labeling" style="font-size:13px;">Transit Number<span class="text-red-500">*</span></label>
                    <input type="text" class="form-control checking-field"
                      formControlName="transit_number" placeholder="Transit Number (5 digits)" maxlength="5"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                      (input)="updateExtraBankVerifyButton(); saveExtraBankToSession()" />
                    @if(extraBankPayForm.get('transit_number')?.invalid && extraBankSubmitted){
                    <div class="invalid text-red-500  mt-1">Transit Number is required</div>
                    }
                  </div>

                  <div class="col-span-1">
                    <label class="labeling" style="font-size:13px;">Account Number<span class="text-red-500">*</span></label>
                    <input type="text" class="form-control checking-field"
                      formControlName="account_number" placeholder="Account Number" maxlength="12"
                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                      (input)="updateExtraBankVerifyButton(); saveExtraBankToSession()" />
                    @if(extraBankPayForm.get('account_number')?.invalid && extraBankSubmitted){
                    <div class="invalid text-red-500  mt-1">Account Number is required</div>
                    }
                  </div>
                </div>

                @if(extraBankerrormsg){
                <div class="invalid text-red-500 mt-2">{{ extraBankerrormsg }}</div>
                }

                <!-- Verify + Reset buttons -->
                <div class="flex gap-3 mt-3">
                  @if(extraBankVerifyButton){
                  <button type="button"
                    class="w-36 h-10 rounded-full border-[1px] border-indigo-200 bg-indigo-200 p-0.5 transition hover:bg-white hover:border-green-500"
                    (click)="verifyExtraBank()">
                    {{ lang.Verify }}
                  </button>
                  }
                  <button type="button"
                    class="w-36 h-10 rounded-full border-[1px] border-indigo-200 bg-gray-200 p-0.5 transition hover:bg-white"
                    (click)="resetExtraBank()">
                    {{ lang.Reset }}
                  </button>
                </div>

                <!-- Step 2: Auto-filled fields shown only after successful verify -->
                @if(extraBankNameRes){
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4 pt-4 border-t border-gray-200">
                  <div class="col-span-1">
                    <label class="labeling">Financial Institute Name</label>
                    <input type="text" class="form-control bg-gray-50"
                      formControlName="financial_institute_name" readonly />
                  </div>

                  <div class="col-span-1">
                    <label class="labeling">Branch Address</label>
                    <input type="text" class="form-control bg-gray-50"
                      formControlName="branch_address" readonly />
                  </div>

                  <div class="col-span-1">
                    <label class="labeling">City</label>
                    <input type="text" class="form-control bg-gray-50"
                      formControlName="extra_city" readonly />
                  </div>

                  <div class="col-span-1">
                    <label class="labeling">Province</label>
                    <input type="text" class="form-control bg-gray-50"
                      formControlName="extra_province" readonly />
                  </div>

                  <div class="col-span-1">
                    <label class="labeling">Upload Void Cheque</label>
                    <input type="file" formControlName="upload_void_cheque"
                      (change)="onExtraBankVoidCheckUpload($event)" />
                  </div>

                  @if(extraBankImageDisplay){
                  <div class="col-span-1 flex items-start pt-5">
                    <div class="void-thumb-wrapper" (click)="showExtraBankVoidCheckPreview()" title="Click to enlarge">
                      @if(!extraBankImageDisplay?.toString()?.startsWith('data:application/pdf')){
                      <img [src]="extraBankImageDisplay" class="void-thumb-img" alt="Void Cheque" />
                      }
                      @if(extraBankImageDisplay?.toString()?.startsWith('data:application/pdf')){
                      <div class="pdf-thumb-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" class="pdf-thumb-icon" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM9 13h6v1H9v-1zm0 3h6v1H9v-1zm0-6h2v1H9v-1z"/>
                        </svg>
                        <span class="pdf-thumb-label">PDF Document</span>
                        <small class="pdf-thumb-hint">Click to view</small>
                      </div>
                      }
                      <div class="void-thumb-overlay">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }

              </form>
              }
            </div>
            }
          </ng-template>
          <!-- ===== End ng-template ===== -->

          @if(paymentForm.get('paymentRadioCheck')?.value === 'CC')
          {
          <div
            class="grid grid-cols-1 sm:grid-cols-3 gap-1 border-[1px] border-indigo-700 backdrop-blur-sm rounded-xl px-2 py-2">

            <!-- <div class="grid grid-cols-1 sm:grid-cols-3 gap-1 bg-gradient-to-bl from-blue-400 via-blue-200 to-blue-400 backdrop-blur-sm rounded-xl px-2 py-2"> -->
            <!-- <span class="bg-gradient-to-r from-[#d5dfe1] to-[#616874] rounded-xl px-4 py-8 w-3/4"> -->
            <div class="col-span-3 sm:col-span-1">
              <label for="firstname" class="labeling"> {{ lang.First_Name
                }}<span style="color: red">*</span></label>
              <input class="form-control" id="firstname" placeholder={{lang.First_Name}} name="FirstName" type="hidden"
                [value]="paymentFirstName" [(ngModel)]="paymentFirstName" [ngModelOptions]="{standalone: true}" />
              <input class="form-control" id="firstname" placeholder={{lang.First_Name}} formControlName="FirstName"
                type="text" [(ngModel)]="paymentFirstName" (keypress)="alphabatesOnly($event)" />
              @if (payment['FirstName'].errors &&
              payment['FirstName'].touched) {
              <div class="invalid text-red-500">
                @if (payment['FirstName'].errors?.['required']) {
                <div>{{ lang.Please_enter_first_name}}</div>
                }
              </div>
              }
              <div id="widget-container" class="custom-widget-wrapper">
                <!-- The script will inject its content here -->
              </div>
            </div>
            <div class="col-span-3 sm:col-span-1">
              <label for="lastname" class="labeling">{{ lang.Last_Name
                }}<span style="color: red">*</span></label>
              <input class="form-control" id="LastName" placeholder={{lang.last_Name}} name="LastName" type="hidden"
                [value]="paymentLastName" [(ngModel)]="paymentLastName" [ngModelOptions]="{standalone: true}" />
              <input class="form-control" id="LastName" placeholder={{lang.last_Name}} formControlName="LastName"
                type="text" [(ngModel)]="paymentLastName" (keypress)="alphabatesOnly($event)" />
              @if (payment['LastName'].errors &&
              payment['LastName'].touched) {
              <div class="invalid text-red-500">
                @if (payment['LastName'].errors?.['required']) {
                <div>{{ lang.Please_enter_last_name}}</div>
                }
              </div>
              }
            </div>
          

            <div class="col-span-2">
              <label for="cardnumnber" class="labeling">{{ lang.Card_Number
                }}<span style="color: red">*</span></label>
              <!-- (input)="credit_card_number($event)" -->
              <!-- <img id="card-image" src="" alt="Card Image"> -->
              <div class="flex items-center gap-2">
              <input class="form-control" id="CardNumber" placeholder={{lang.Card_Number}} name="CardNumber"
                formControlName="CardNumber" (input)="creditcardlblurmethod($event)" (keypress)="
                        ($event.charCode >= 48 && $event.charCode < 58)
                      " />
                @if(cardType){
                <img class="w-20 h-14" src={{cardType}} />
                }

              </div>

              @if (payment['CardNumber'].errors &&
              payment['CardNumber'].touched) {
              <div class="invalid text-red-500">
                @if (payment['CardNumber'].errors?.['required']) {
                <div>{{ lang.Please_enter_Card_number }}</div>
                } @if
                (payment['CardNumber'].errors?.['invalidcreditcarddetails'])
                {
                <div>{{ lang.Please_enter_valid_Card_number }}</div>
                }
                @else{
                @if(invalidcreditcard==true){

                <div class="invalid text-red-500">
                  {{ lang.Please_enter_valid_Card_number }}
                </div>

                }
                }
              </div>
              }



            </div>
            <div class="col-span-1"></div>
            <div class="col-span-3 sm:col-span-1">
              <label for="expirymonth" class="labeling">{{ lang.Expiry_Month
                }}<span style="color: red">*</span></label>

              <select class="form-control" id="ExpirationMonth" name="ExpirationMonth"
                (change)="filterExpiryDate($event)" formControlName="ExpirationMonth" placeholder="MM">
                <option value="" disabled selected>
                  {{ lang.Select }}
                </option>
                <option value="01">Jan</option>
                <option value="02">Feb</option>
                <option value="03">Mar</option>
                <option value="04">April</option>
                <option value="05">May</option>
                <option value="06">June</option>
                <option value="07">July</option>
                <option value="08">Aug</option>
                <option value="09">Sept</option>
                <option value="10">Oct</option>
                <option value="11">Nov</option>
                <option value="12">Dec</option>
              </select>
              @if (payment['ExpirationMonth'].errors &&
              payment['ExpirationMonth'].touched) {
              <div class="invalid text-red-500">
                @if (payment['ExpirationMonth'].errors?.['required']) {
                <div>{{ lang.Please_select_expiry_month }}</div>
                } @if (payment['ExpirationMonth'].errors?.['min']) {
                <div>minim</div>
                } @if (payment['ExpirationMonth'].errors?.['max']) {
                <div>maxmim</div>
                }
              </div>
              }
              <!-- @if (payment['ExpirationMonth'].errors?.['invalidcreditcarddetails']) {
                                        <div>{{ lang.please_enter_valid_credit_card }}</div>
                                        } -->
              <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExpirationMonth').touched &&
                                        paymentForm
                                          .get('ExpirationMonth')
                                          .hasError('required')
                                      "
                                      >{{lang.please_select_expiry_month}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpirymontherror"
                                      >{{lang.please_enter_valid_expiry_month}}</span
                                    > -->
            </div>
            <div class="col-span-3 sm:col-span-1">
              <label for="expiryyear" class="labeling">{{ lang.Expiry_Year
                }}<span style="color: red">*</span></label>

              <select class="form-control" id="ExpirationYear" placeholder="YY" name="ExpirationYear"
                (change)="filterExpiryDate($event)" formControlName="ExporationYear">
                <option value="" disabled selected>
                  {{ lang.Select }}
                </option>
                <option *ngFor="let item of [].constructor(40); let i = index" value="{{ i + 25 }}">
                  {{ i + 2025 }}
                </option>
              </select>
              @if (payment['ExporationYear'].errors &&
              payment['ExporationYear'].touched) {
              <div class="invalid text-red-500">
                @if (payment['ExporationYear'].errors?.['required']) {
                <div>{{ lang.Please_select_expiry_year }}</div>
                } @if (payment['ExporationYear'].errors?.['expiryDate']) {
                <div>cant minimminim</div>
                }
              </div>
              }
              <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExporationYear').touched &&
                                        paymentForm.get('ExporationYear').hasError('required')
                                      "
                                      >{{lang.please_select_expiry_year}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpiryyearerror"
                                      >{{lang.please_enter_valid_expiry_year}}</span
                                    > -->
            </div>

            <div class="col-span-3 sm:col-span-1">
              <label for="cvv" class="labeling">{{ lang.CVV }}<span style="color: red">*</span></label>

              <input class="form-control" id="Cvv" placeholder={{lang.CVV}} name="Cvv" formControlName="cvv"
                maxlength="4" (keypress)="
                        ($event.charCode >= 48 && $event.charCode < 58)
                      " />
              @if (payment['cvv'].errors && payment['cvv'].touched) {
              <div class="invalid text-red-500">
                @if (payment['cvv'].errors?.['required']) {
                <div>{{ lang.Please_enter_cvv }}</div>
                } @if (payment['cvv'].errors?.['minlength']) {
                <div>{{ lang.CVV_must_be_3_or_4_digits }}</div>
                }
              </div>
              }
            </div>


            @if(invalidCardDetails){
            <div class="col-span-3">
              <span class="invalid text-red-500">{{lang.Please_enter_the_correct_Month_and_Year}}</span>
            </div>
            }
          </div>

          <!-- </span> -->
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
            <div class="col-span-3">
              <input type="checkbox" (click)="homeaddresscheckCC($event)" />&nbsp;<span class="paymentaddress" class="labeling">{{
                lang.Home_Address_same_as_billing_Address }}
              </span>
            </div>

            <div class="col-span-3 sm:col-span-1">
              <label for="maidenname" class="labeling">{{ lang.Street_Address
                }}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="Address1" placeholder={{lang.Street_Address}}
                formControlName="streetaddress" autocomplete="off" />
              <input type="hidden" name="Address1" />
              @if (payment['streetaddress'].errors &&
              payment['streetaddress'].touched) {
              <div class="invalid text-red-500">
                @if (payment['streetaddress'].errors?.['required']) {
                <div>{{ lang.Please_enter_Street_Address}}</div>
                }
              </div>
              }
            </div>
            <div class="col-span-3 sm:col-span-1">
              <label for="maidenname" class="labeling">{{ lang.Street_Address_Line_2 }}<span></span></label>
              <input type="text" class="form-control" id="Address2" formControlName="streetaddressline2"
                autocomplete="off" placeholder={{lang.Street_Address_Line_2}} />
              <input type="hidden" name="Address2" />
            </div>
            <div class="col-span-3 sm:col-span-1"></div>

            <div class="col-span-3 sm:col-span-1">
              <label for="maidenname" class="labeling">{{ lang.City }}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="City" placeholder={{lang.City}}
                formControlName="city" />
              <input type="hidden" name="City" />
              @if (payment['city'].errors && payment['city'].touched) {
              <div class="invalid text-red-500">
                @if (payment['city'].errors?.['required']) {
                <div>{{ lang.Please_enter_City }}</div>
                }
              </div>
              }
            </div>
            <div class="col-span-3 sm:col-span-1">
              <label for="Province" class="labeling">{{ lang.Province }}<span style="color: red">*</span></label>

              <select class="form-control" id="StateId" placeholder="select" formControlName="province"
                (change)="provincelistCreditPayment($event)" autocomplete="off">
                <option value="">{{ lang.Select }}</option>
                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <input type="hidden" name="StateId" />

              @if (payment['province'].errors && payment['province'].touched) {
              <div class="invalid text-red-500">
                @if (payment['province'].errors?.['required']) {
                <div>{{ lang.Please_select_Province }}</div>
                }
              </div>
              }
            </div>
            <div class="col-span-3 sm:col-span-1">
              <label for="maidenname" class="labeling">{{ lang.Postal_Code }}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="PostalZip" formControlName="postalcode"
                autocomplete="off" placeholder={{lang.Postal_Code}}
                (input)="changeTextToUppercaseCreditPayment('postalcode',$event)" />
              <input type="hidden" name="PostalZip" />

              @if (payment['postalcode'].errors && payment['postalcode'].touched) {
              <div class="invalid text-red-500">
                @if (payment['postalcode'].errors?.['required']) {
                <div>{{ lang.Please_enter_postal_code }}</div>
                }
              </div>
              } @if (creditCradInvalidProvince==true) {
              <div class="invalid text-red-500">
                {{ lang.Please_enter_valid_Postal_Code }}
              </div>
              }
            </div>
            <!-- Extra bank account section — CC flow -->
            <ng-container *ngTemplateOutlet="extraBankSection"></ng-container>

            <div class="col-span-3">
              <label for="signature" class="labeling">Please sign in the box below<span style="color: red">*</span></label>

              <div class="signature-container sm:w-1/2" style="border:3px solid #222;border-radius: 4px;">

                <!-- <button class="btn btn-primary btn-inline" (click)="clearPadcc()" [disabled]="signaturecheckvalue1cc">Clear</button> -->

                <!-- <canvas
                #canvascc
                (touchstart)="startDrawingcc($event)"
                (touchmove)="movedcc($event)"
                (click)="signaturestartcc($event)" required
              ></canvas> -->

                <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
                  (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
                  (onBeginEvent)="drawStart()"></signature-pad>
                @if(signaturecheckvalue1cc){
                <div style="
              left: 10px;
              color: red;
              text-decoration: underline;cursor:pointer">
                  <p (click)="clearSignature()">x {{lang.Clear}}</p>
                </div>
                }

                <!-- <canvas
                #sigPad
                (mousedown)="onMouseDown($event)" (touchstart)="onMouseDown($event)" (touchmove)="onMouseMove($event)"
    (mousemove)="onMouseMove($event)" required  style="border: 1px solid #ccc;border-radius: 4px;"
              ></canvas> -->

                <!-- @if(signaturecheckvalue1cc){
              <div style="
              left: 10px;
              color: red;
              text-decoration: underline;cursor:pointer">
                  <p (click)="clearCreditCardSignature()">x {{lang.clear}}</p>
              </div>
            } -->


              </div>
              @if(signaturemessagecc){
              <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
              }
            </div>
            <div class="col-span-3">
              <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                siteKey="{{ fusbillinfocaptchavalue }}">
              </re-captcha>

              <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
              @if (payment['recaptchaReactive'].errors &&
              payment['recaptchaReactive'].touched) {
              <div class="invalid text-red-500">
                @if (payment['recaptchaReactive'].errors?.['required']) {
                <div>{{ lang.Please_Check_re_Captcha_Validation }}</div>
                }
              </div>
              }
            </div>
          </div>

          }


          @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD')
          {
          <form [formGroup]="bankpayForm" #bankForm="ngForm">
            <!-- <div class="grid grid-cols-1 sm:grid-cols-6 gap-2"> -->
            <!-- style="max-width:90px;margin-left:5px" -->

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
              <div class="col-span-3 sm:col-span-1">
                <label for="cardnumnber" class="labeling">Bank Code<span style="color: red">*</span></label>
                <input class="form-control checking-field" id="banknumber" placeholder="{{ lang.Bank_Code }}"
                  name="banknumber" autocomplete="off" formControlName="banknumber" maxlength="3" (input)="touchedmsg()"
                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />

                @if (bankpay['banknumber'].errors &&
                bankpay['banknumber'].touched) {
                <div class="invalid text-red-500">
                  @if (bankpay['banknumber'].errors?.['required']) {
                  <div>{{ lang.Please_enter_bank_code }}</div>
                  }
                  @if (bankpay['banknumber'].errors?.['checkbanknumbervalidator']) {
                  <div>{{ lang.Bank_code_must_be_3_digits }}</div>
                  }
                </div>
                }

              </div>
              <!-- style="max-width:120px;" -->
              <div class="col-span-3 sm:col-span-1">
                <label for="transitnumber" class="labeling">{{ lang.Transit
                  }}<span style="color: red">*</span></label>
                <!-- (input)="credit_card_number($event)" -->
                <input class="form-control checking-field" id="branch" placeholder={{lang.Transit}} name="branch"
                  formControlName="transitnumber" autocomplete="off" maxlength="5" (input)="touchedmsg()"
                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                @if (bankpay['transitnumber'].errors &&
                bankpay['transitnumber'].touched) {
                <div class="invalid text-red-500">
                  @if (bankpay['transitnumber'].errors?.['required']) {
                  <div>{{ lang.Please_enter_bank_transit }}</div>
                  }
                  @if (bankpay['transitnumber'].errors?.['checktransitnumbervalidator']) {
                  <div>{{ lang.Bank_transit_must_be_5_digits }}</div>
                  }
                </div>
                }

              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="accountNumber" class="labeling">{{ lang.Account_Number
                  }}<span style="color: red">*</span></label>
                <!-- (input)="credit_card_number($event)" -->
                <input class="form-control checking-field" id="accountnumber" placeholder={{lang.Account_Number}}
                  autocomplete="off" name="accountnumber" formControlName="accountnumber" maxlength="12"
                  (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                @if (bankpay['accountnumber'].errors &&
                bankpay['accountnumber'].touched) {
                <div class="invalid text-red-500">
                  @if (bankpay['accountnumber'].errors?.['required']) {
                  <div>{{ lang.Please_enter_Account_number }}</div>
                  }
                  @if (bankpay['accountnumber'].errors?.['checkaccountnumbervalidator']) {
                  <div>{{ lang.Account_Number_must_be_5_12_digits }}</div>
                  }
                </div>
                }


              </div>
              @if(bankerrormsg){
              <div class="col-span-3 invalid text-red-500 ">{{bankerrormsg}}</div>
              }


              
              <div class="col-span-3">
                @if(verifybankdetails && verifybutton){
                <button type="submit"
                  class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-200 bg-indigo-200 p-0.5 transition duration-700 ease-in-out hover:bg-white hover:border-green-500"
                  (click)="verifybank()">
                  {{lang.Verify}}
                </button>&nbsp;

                }

                @if(verifybankdetails){

                <button type="submit"
                  class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-200 bg-gray-200 p-0.5  transition duration-700 ease-in-out hover:bg-white"
                  (click)="checkbankdetails($event)">
                  {{lang.Reset}}
                </button>
                }


                <!-- <form class="signbtn">
                      <button class="btn btn-primary btn-inline"  *ngIf="(verifybankdetails && verifybutton)"  (click)="verifybank()" style="margin-left:5px">{{lang.verify}}</button>
                      <button class="btn btn-primary btn-inline" *ngIf="verifybankdetails"  id="no" value="no" (click)="checkbankdetails($event)" >{{lang.reset}}</button>
                    </form>
                    <div class="clearfix"></div> -->


                <!-- <span *ngIf="(bankdetailsverify && verifybankdetails)"  class="help-block text-danger" style="margin-top:20px;margin-left:10px">{{lang.please_verify_the_bank_details}}</span> -->

              </div>

              <div class="col-span-3">
                <label for="bankdetails" class="labeling">{{ lang.Bank_Details }}</label>
                <!-- (input)="credit_card_number($event)" -->
                 <textarea class="form-control" id="bankname" placeholder="{{ lang.bank_details }}" name="bankname"
                    formControlName="bankname" style="color: rgba(85, 85, 85, 0.9)" [ngModel]="banknameres"
                    rows="2"></textarea>
                @if (bankpay['bankname'].errors &&
                bankpay['bankname'].touched) {
                <div class="invalid text-red-500">
                  @if (bankpay['bankname'].errors?.['required']) {
                  <div>{{ lang.Please_verify_the_bank_details }}</div>
                  }

                </div>
                }


              </div>




               <div class="col-span-3">
                  <label for="uploadvoidChequeNhlaa">{{ lang.Upload_Void_Cheque
                    }}<span style="color: red">*</span></label>

                  <!-- Hidden native input — keeps formControlName for Angular validation -->
                  <input #voidInputNhlaa type="file" id="uploadvoidChequeNhlaa"
                    formControlName="voidcheck"
                    (change)="voidcheckupload($event)"
                    accept=".jpg,.jpeg,.png,.pdf"
                    style="display:none" />

                  <!-- Custom upload button row -->
                  <div class="void-upload-row">
                    <button type="button" class="void-upload-btn" (click)="voidInputNhlaa.click()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                      </svg>
                      {{ lang.Choose_file || 'Choose file' }}
                    </button>
                    <span class="void-upload-filename">{{ voidCheckFileDisplayName || (lang.No_file_selected || 'No file selected') }}</span>
                  </div>

                  @if (bankpay['voidcheck'].errors && bankpay['voidcheck'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['voidcheck'].errors?.['required']) {
                    <div>{{ lang.Please_Upload_Void_Cheque_file }}</div>
                    }
                  </div>
                  }

                  @if(imagedisplay){
                  <div class="void-card-preview" (click)="showvoidcheckpreview()" title="Click to enlarge">
                    @if(normalview){
                    <img [src]="imagedisplay" class="void-card-img" alt="Void Cheque" />
                    }
                    @if(pdfview){
                    <div class="void-card-pdf">
                      <svg xmlns="http://www.w3.org/2000/svg" class="void-card-pdf-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM9 13h6v1H9v-1zm0 3h6v1H9v-1zm0-6h2v1H9v-1z"/>
                      </svg>
                      <span class="void-card-pdf-name">PDF Document</span>
                      <small class="void-card-pdf-hint">{{ lang.Click_to_view_full_document || 'Click to view full document' }}</small>
                    </div>
                    }
                    <span class="void-card-enlarge-pill">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                      </svg>
                      <!-- {{ lang.Click_to_enlarge || 'Click to enlarge' }} -->
                    </span>
                  </div>
                  }
                </div>


              <!-- Billing address is auto-filled with home address when PAD is selected (see paymentmethod() in TS) -->
              <!-- Hidden inputs keep the bankpayForm values in sync for form submission -->
              <input type="hidden" formControlName="bankstreetaddress" />
              <input type="hidden" formControlName="bankstreetaddressline2" />
              <input type="hidden" formControlName="bankcity" />
              <input type="hidden" formControlName="bankprovince" />
              <input type="hidden" formControlName="bankpostalcode" />


              </div>



              <!-- Extra bank account section — PAD flow -->
              <ng-container *ngTemplateOutlet="extraBankSection"></ng-container>


               <div class="col-span-3">
              <label for="signature" class="labeling">Please sign in the box below<span style="color: red">*</span></label>

              <div class="signature-container sm:w-1/2" style="border:3px solid #222;border-radius: 4px;">
               
                <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
                    (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
                    (onBeginEvent)="drawStart()"></signature-pad>
                  @if(signaturecheckvalue1cc){
                  <div style="
                  left: 10px;
                  color: red;
                  text-decoration: underline;cursor:pointer">
                      <p (click)="clearSignature()">x {{lang.Clear}}</p>
                    </div>
                    }

                  </div>
                  @if(signaturemessagecc){
                  <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
                  }
                </div>

              <div class="col-span-3">

                <button type="button"
                *ngIf="isFileUploaded && bankverifyDetails"
                  class="w-full sm:w-1/2 h-14 mb-1 max-2 rounded-full border-[1px] border-indigo-200 bg-indigo-200 p-0.5  transition duration-700 ease-in-out text-black mt-2"
                  (click)="generateAndSubmitPAD(true)">
                  Review the PAD Agreement
                </button>
                <span class="invalid text-red-500">{{padaggrementerror}}</span>
              </div>

          </form>

          }




        </form>
      </div>
      <!-- First column -->

      <!-- Second column -->
      <div class="col-span-1 bg-white text-white">
        <!-- <div
          class="main"
          style="flex: 1; padding: 18.5px; overflow-x: auto"
        > -->
        <!-- <div
        class="form-row"
        *ngIf="finalenrollemntsummary.length == 0 ? false : true"
      > -->
        <div class="form-row" *ngIf="finalenrollemntsummary.length>0 || finalenrollemntsummaryLife.length>0 ">
          <div class="form-group col-md-12">



            <div>
              <table class="table table-bordered text-black font-thin" id="customerPlansTable">
                <!-- <thead>
                  <tr>
                    <th colspan="6" style="font-size: 14px;background-color: #ffff;">{{lang.plans_summary}}</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr class="bg-indigo-200">
                    <th class="w45">{{lang.Plan}}</th>
                    <!-- <th class="w25"></th> -->
                    <th class="w10" style="white-space: nowrap;">{{lang.Coverage}}</th>
                    <th class="w10" style="white-space: nowrap;" *ngIf="isMedcanPopUpSubmitted">{{lang.Units}}</th>
                    <th class="align-center w15">{{lang.Amount || 'Amount'}} <br /><span style="font-size: 10px;">(Per
                        Unit)</span></th>
                        <!-- here we need to checkthis check this -->
                    <th class="align-center w15">{{lang.Tax}}<br /> <span style="font-size: 10px;">(Per Unit)</span>
                    </th>
                    <th class="align-center w15">{{lang.Total}}</th>
                  </tr>
                  <ng-container *ngFor="
                let plan of finalenrollemntsummary;
                let i = index">
                    <tr style="background-color:#ffff">
                      <td colspan="6">
                        {{plan.packagename}}
                      </td>
                    </tr>
                    <tr *ngFor="let product of plan.products;let j = index">
                      <td>
                        {{product.name}}
                      </td>

                      <td class="align-center">

                        <span
                          *ngIf="product.planCoverage =='SINGLE' || product.planCoverage =='COUPLE' || product.planCoverage =='FAMILY';else placheck">{{capitalizeFirstLetter(product.planCoverage)}}
                        </span>


                        <ng-template #placheck>---</ng-template>

                      </td>
                      <td *ngIf="isMedcanPopUpSubmitted">
                        <span *ngIf="plan.planLevel==15;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                        <ng-template #defaultSubmitCheck>-</ng-template>
                      </td>
                      <td class="align-right">
                        {{product.calculatedTax.price | currency:"USD"}}&nbsp;
                      </td>
                      <td class="align-right">
                        {{product.calculatedTax.tax | currency:"USD"}}&nbsp;
                      </td>
                      <td class="align-right" style="white-space: nowrap;">
                        {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngFor="
                let plan of finalenrollemntsummaryLife;
                let i = index">
                    <tr style="background-color:#ffff">
                      <td colspan="6">&nbsp;
                        {{plan.packagename}}
                      </td>
                    </tr>
                    <tr *ngFor="let product of plan.products;let j = index">
                      <td>&nbsp;
                        {{plan.name}}
                      </td>

                      <td class="align-center">
                        <span *ngIf="plan.coverage =='MEMBER' || plan.coverage =='MEMBER & SPOUSE';else placheck">
                          <span>
                            @if(plan.coverage =='MEMBER'){
                            {{lang.MEMBER}}
                            }
                            @else{
                            {{lang.Member_Spouse}}
                            }
                          </span>
                        </span>
                        <ng-template #placheck>---</ng-template>

                      </td>
                      <td class="align-right">

                        <span>{{lang.MEMBER}}:</span>

                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Units}}</td>
                              <td>({{plan.member.coverageValue/plan.member.standardUnits}})</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Premium}}</td>
                              <td>{{plan.member.premium | currency:"USD"}}</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Amount}}</td>
                              <td>{{plan.member.amount | currency:"USD"}}</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                              <td>
                                @if(plan.member.defaultRange>=plan.member.maximumCoverageWithoutEvidence){
                                {{plan.member.maximumCoverageWithoutEvidence | currency:"USD"}}
                                }
                                @else{
                                {{plan.member.defaultRange | currency:"USD"}}
                                }

                              </td>

                            </tr>
                            @if(plan.member.maximumCoverageWithoutEvidence>plan.member.defaultRange){
                            <tr class=" ">
                              <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                              <td>

                                {{plan.member.maximumCoverageWithoutEvidence-plan.member.defaultRange | currency:"USD"}}



                              </td>

                            </tr>
                            }
                          </tbody>
                        </table>

                        @if(plan.coverage =='MEMBER & SPOUSE'){

                        <span>{{lang.SPOUSE}}:</span>
                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Units}}</td>
                              <td>({{plan.spouse.coverageValue/plan.spouse.standardUnits}})</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Premium}}</td>
                              <td>{{plan.spouse.premium | currency:"USD"}}</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Amount}}</td>
                              <td>{{plan.spouse.amount | currency:"USD"}}</td>

                            </tr>
                            <tr class=" ">
                              <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                              <td>
                                @if(plan.spouse.defaultRange>=plan.spouse.maximumCoverageWithoutEvidence){
                                {{plan.spouse.maximumCoverageWithoutEvidence | currency:"USD"}}
                                }
                                @else{
                                {{plan.spouse.defaultRange | currency:"USD"}}
                                }

                              </td>

                            </tr>
                            @if(plan.spouse.maximumCoverageWithoutEvidence>plan.spouse.defaultRange){
                            <tr class=" ">
                              <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                              <td>

                                {{plan.spouse.maximumCoverageWithoutEvidence-plan.spouse.defaultRange | currency:"USD"}}



                              </td>

                            </tr>
                            }
                          </tbody>
                        </table>

                        }
                    <tr>
                      @if(plan.coverage =='MEMBER & SPOUSE'){
                      <td>{{lang.Total}}:${{plan.member.amount+plan.spouse.amount | number : '1.2-2'}} + {{staticCalc}}</td>
                      }
                      @if(plan.coverage =='MEMBER'){
                      <td>{{lang.Total}}:${{plan.member.amount | number : '1.2-2'}} + {{staticCalc}}</td>
                      }
                    </tr>
                    <!-- {{product.calculatedTax.price  | currency:"USD"}}&nbsp; -->
                    </td>
                    <td class="align-right">
                      <!-- <strong>Member:</strong>

                    <table class="table text-nowrap" style="font-size:12px">

                      <tbody>


                        <tr class=" ">
                          <td class=" border-right">Tax</td>
                          <td>{{plan.member.tax | currency:"USD"}}</td>

                        </tr>
                      </tbody>
                    </table> -->

                      <!-- @if(plan.coverage =='MEMBER & SPOUSE'){

                    <strong>Spouse:</strong>
                    <table class="table text-nowrap" style="font-size:12px">

                      <tbody>

                        <tr class=" ">
                          <td class=" border-right">Tax</td>
                          <td>{{plan.spouse.tax | currency:"USD"}}</td>

                        </tr>

                      </tbody>
                    </table>

              } -->
                      <tr>
                        @if(plan.coverage =='MEMBER & SPOUSE'){
                        <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                        }
                        @if(plan.coverage =='MEMBER'){
                        <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                        }
                      <tr>
                        <!-- {{product.calculatedTax.tax  | currency:"USD"}}&nbsp; -->
                    </td>
                    <td class="align-right">
                      {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                    </td>
                    </tr>
                  </ng-container>


                  <tr class="bg-indigo-200">
                    <td *ngIf="isMedcanPopUpSubmitted" colspan="5"><b>{{lang.Total}}</b></td>
                    <td *ngIf="!isMedcanPopUpSubmitted" colspan="4"><b>{{lang.Total}}</b></td>
                    <!-- <td colspan="3"></td> -->
                    <td class="grandTotal align-right">
                      {{planAmount | currency:"USD"}}&nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />



            </div>
          </div>
        </div>

        <div class="form-row optclass" *ngIf="planssummaryopt.length == 0 ? false : true">
          <div class="form-group col-md-12">
            <label for="cardnumnber"><strong class="labeling">{{lang.opt_in_plans_summary}}</strong></label>

            <div>
              <table class="shopping">
                <tbody>
                  <tr>
                    <!-- <th>S. no</th> -->
                    <th>{{lang.Plan}}</th>
                    <th>{{lang.Details}}</th>
                    <!-- <th class="taxamount"> Amount</th>

                  <th class="taxamount">Tax</th>
                  <th class="taxamount">Total</th> -->
                  </tr>
                  <tr *ngFor="
                        let item of planssummaryopt;
                        let i = index
                      ">
                    <!-- <td>{{i+1}}</td> -->
                    <!-- {{item.groupName | lowercase}}- -->

                    <td>
                      {{ item.planname }}<br />({{
                      item.packagename
                      }})
                    </td>
                    <td>{{ item.details }}</td>
                    <!-- <td class="taxamount">{{currencySymbol}}{{item.planPrice | number : '1.2-2'}}</td>

                  <td class="taxamount"><span *ngIf="item.gstCheck" class="gsttaxes">{{item.gstPrice==0?"-":"(GST)&nbsp;"+currencySymbol+(item.gstPrice | number : '1.2-2')}}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{item.pstPrice==0?"-":"(PST)&nbsp;"+currencySymbol+(item.pstPrice | number : '1.2-2')}}</span><span *ngIf="item.hstCheck"  class="gsttaxes">{{item.hstPrice==0?"-":"(HST)&nbsp;"+currencySymbol+(item.hstPrice | number : '1.2-2')}}</span><span *ngIf="!item.gstCheck && !item.pstCheck && !item.hstCheck ">-</span></td>
                  <td class="grandTotal">{{currencySymbol}}{{item.totalPrice | number : '1.2-2'}}</td> -->
                  </tr>

                  <tr>
                    <!-- <td>Total </td><td colspan="2"></td><td class="grandTotal">{{currencySymbol}}0.00</td> -->
                  </tr>
                  <!-- <tr>
                  <td colspan="3">

                  </td>
                  <td colspan="2" class="grandTotal">Total:&nbsp;{{currencySymbol}}{{planAmount | number : '1.2-2'}}</td>
                </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>




        <!-- </div> -->
      </div>

      <!-- Second column -->
    </div>

    <br>
    <div class="col-span-2 overflow-scroll">
      @if(addbenificaryData.length>0){
      <div class="w-[77%]">
        <table class="table table-bordered text-black" id="customerPlansTable">
          <thead>
            <tr>
              <th style="font-size: 14px;background-color: #ffff;">{{lang.Beneficiary_Information}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- <th>{{lang.Type}}</th> -->
              <!-- <th>{{lang.First_Name}}</th>
              <th>{{lang.Last_Name}}</th> -->
              <th>Name</th>
              <th>{{lang.Gender}}</th>
              <th>{{lang.Relation}}</th>
              <!-- <th>{{lang.Minor}}</th> -->
              <th>{{lang.Date_of_Birth}}</th>
              <!-- <th>{{lang.Contingent_First_Name}}</th>
              <th>{{lang.Contingent_Last_Name}}</th> -->
              <!-- <th>{{lang.Trustee_First_Name}}</th>
              <th>{{lang.Trustee_Last_Name}}</th> -->
              <th>Trustee Name - Relation</th>
              <th>{{lang.Percentage}}</th>
              <th>{{lang.Action}}</th>
            </tr>

            <tr *ngFor="
                  let broker of addbenificaryData;
                  let i = index
                " [ngClass]="{
                  orange: i % 2 == 0,
                  white: i % 2 != 0
                }">

              <!-- <td>{{capitalizeFirstLetter(broker.customerType)}}</td> -->

              <!-- <td>
                {{capitalizeFirstLetter(broker.firstName)}}
              </td>
              <td>
                {{capitalizeFirstLetter(broker.lastName)}}
              </td> -->
              <td>
                {{capitalizeFirstLetter(broker.firstName) + ' ' +capitalizeFirstLetter(broker.lastName)}}
              </td>
              <td>
                {{capitalizeFirstLetter(broker.gender)}}
              </td>
              <!-- <td>
                {{capitalizeFirstLetter(broker.relationship)}}
              </td> -->
              <td>
                @if(broker.relationship.toLowerCase()=="other"){
                {{capitalizeFirstLetter(broker.relationshipSpecific ?? '')}}
                }@else{
                {{capitalizeFirstLetter(broker.relationship ?? '')}}
                }
              </td>
              <!-- <td>
                @if(broker.isMinor=="true"){
                Yes
                }@else{
                No
                }
              </td> -->

              <td>

                {{broker.dob | displayDate}}
              </td>

              <!-- <td>
                {{capitalizeFirstLetter(broker.contingentFirstName)}}
              </td>
              <td>
                {{capitalizeFirstLetter(broker.contingentLastName)}}
              </td> -->
              <!-- <td>

                @if(broker.trusteeFirstName==""){
                NA
                }@else{
                {{capitalizeFirstLetter(broker.trusteeFirstName)}}
                }

              </td>
              <td>
                @if(broker.trusteeLastName==""){
                NA
                }@else{
                {{capitalizeFirstLetter(broker.trusteeLastName)}}
                }
              </td> -->
              <td>
                @if(broker.trusteeFirstName==""){
                NA
                }@else{
                {{broker.trusteeFirstName+ ' '+broker.trusteeLastName + ' - '+broker.trusteeRelation}}
                }
              </td>

              <td>
                {{broker.percentage}}
              </td>

              <td class="thBottomNone text-center inline-flex items-center">
                <svg class="h-10 w-10 text-green-600" (click)="editbenficiary($event, i, broker)"
                  *ngIf="enableEditIndex != i" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                  <line x1="16" y1="5" x2="19" y2="8" />
                </svg>
                <svg class="h-9 w-9 text-red-600" (click)="deleteBenficiary(broker, i)" *ngIf="enableEditIndex != i"
                  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <rect x="3" y="4" width="18" height="4" rx="2" />
                  <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                  <line x1="10" y1="12" x2="14" y2="12" />
                </svg>


              </td>

            </tr>
          </tbody>
        </table>


      </div>

      }
    </div>


    <div class="relative">

      <!-- Left Button -->
      <!-- <button class="fixed left-0 bottom-16  w-36 h-14 mb-1 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold mx-2 sm:mx-12 hover:bg-white" (click)="gotoPlansPage()">
        {{ lang.previous }}
      </button> -->


      <button
        class="fixed text-center inline-flex items-center left-3 sm:left-16 lg:left-24 bottom-16 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
        (click)="gotoPlansPage()" style="width: 120px;">
        <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        {{ lang.Previous }}
      </button>
      <!-- Right Button -->
      @if(paymentForm.get('paymentRadioCheck')?.value === 'CC'){


      <button
        class="fixed right-3 sm:right-16 lg:right-24 bottom-16 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 hover:bg-white"
        (click)="creditcardpaysubmit2(paymentForm.value,paymentform2)">
        {{ lang.Submit }}
      </button>
      }
      @else{

      <button
        class="fixed right-3 sm:right-16 lg:right-24 bottom-16 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 hover:bg-white"
        (click)="bankpayformsubmit2(bankpayForm.value)">
        {{ lang.Submit }}
      </button>

      }

    </div>
    </ng-container><!-- /ng-container currForm !== 'CORP' -->

    }<!-- /activeTab === 2 -->
  </div>
</div>
@if(languageData){
<app-confirmation-model [show]="showDeleteModal" [languageData]="languageData" [message]="modalMessage"
  (confirmed)="onConfirmed($event)">
</app-confirmation-model>
}

@if(showModelDialog || showPADModelDiaslog){
<app-model-dialog [show]="showModelDialog" [showPAD]="showPADModelDiaslog" [languageData]="languageData"
  [message]="pdfData" [headMessage]="header" (pdfconfirmed)="onPdfConfirmed($event)"
  (padPdfconfirmed)="onPADPdfConfirmed($event)">
</app-model-dialog>
}

@if(showModal && languageData){
<app-forms-model [show]="showModal" [editChildData]="editChildInfo" [languageData]="languageData"
  [buttonInfo]="childInfoModalAddAndUpdateButton" (submitForm)="onSubmitForm($event)"
  [formConfigData]="languageTokensArray" [allValidationsFormConfig]="allValidations"
  [childFieldsConfig]="formFieldsUpdated?.child_modal_fields" [currFormType]="currFormType"
  (close)="onCloseModal()">
</app-forms-model>
}
@if(ShowModelPopup && languageData){
<app-modelpopupconfirmation [show]="ShowModelPopup" [languageData]="languageData"
  [showHeaderMessage]="ShowModelPopupTitle" [showModelContent]="ShowModelPopupMessage"
  (closedModelpopup)="onClosedModelpopup($event)">

</app-modelpopupconfirmation>
}

<!-- Viking: told the member which spouse/dependents were ticked for them after they chose a
     Couple or Family coverage. Same shell as the Provincial Health Coverage dialog. -->
@if(addToPlanNoticeModal){
<div class="relative z-10" aria-labelledby="add-to-plan-notice-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white"
                 id="add-to-plan-notice-title">
              {{ lang.Add_to_plan || 'Add to plan' }}
            </div>
            <div class="text-left mx-4 my-4" style="max-height: calc(100vh - 300px); overflow-y: auto;">
              @if(addToPlanNoticeAction === 'unchecked'){
                <p>
                  You selected <strong>{{ addToPlanNoticeCoverage }}</strong> coverage, which covers you only.
                  We have removed the <strong>Add to plan</strong> selection for
                  <strong>{{ addToPlanNoticeNames.join(', ') }}</strong>.
                </p>
              } @else {
                <p>
                  We have checked <strong>Add to plan</strong> for
                  <strong>{{ addToPlanNoticeNames.join(', ') }}</strong>
                  because you selected <strong>{{ addToPlanNoticeCoverage }}</strong> coverage.
                </p>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 hover:bg-white"
            (click)="closeAddToPlanNotice()">
            {{ lang.Close || 'Close' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Viking: Couple coverage covers the member plus one dependent. When there is more than one
     candidate the member picks who that is, and the choice is written back to their record. -->
@if(addToPlanChooserModal){
<div class="relative z-10" aria-labelledby="add-to-plan-modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white"
                 id="add-to-plan-modal-title">
              {{ lang.Add_to_plan || 'Add to plan' }}
            </div>
            <div class="text-left mx-4 my-4" style="max-height: calc(100vh - 300px); overflow-y: auto;">
              <p class="mb-3">
                Couple coverage includes you and one dependent. Please choose who should be added to the plan.
              </p>
              @for(option of addToPlanChooserOptions; track option.key){
                <div class="checkbox-row mb-2">
                  <input type="checkbox" class="shrink-0"
                         [id]="'addToPlanChoice_' + option.key"
                         [checked]="option.selected"
                         (change)="toggleAddToPlanChoice(option.key, $any($event.target).checked)" />
                  <label class="labeling mb-0 cursor-pointer" [for]="'addToPlanChoice_' + option.key">
                    {{ option.label }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 hover:bg-white disabled:opacity-50"
            [disabled]="!addToPlanChoiceMade"
            (click)="confirmAddToPlanChooser()">
            {{ lang.Save || 'Save' }}
          </button>
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 sm:mr-2 rounded-full border-2 border-indigo-200 bg-white p-0.5 hover:bg-indigo-200"
            (click)="closeAddToPlanChooser()">
            {{ lang.Close || 'Close' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(missingInformation){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Missing_Information}}
            </div>
            <div class="text-left mx-2" style="  max-height: calc(100vh - 300px);
        overflow-y: auto;">
              @for(item of missingInfo; track item;let i=$index){
              <div>
                <span>{{i+1}}.&nbsp;{{item}}&nbsp;<span style="color: red">*</span></span>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="closemissingInfoModel()">
            {{lang.Close}}
          </button>
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(noProvincialCoverageModal){
<div class="relative z-10" aria-labelledby="no-provincial-modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{ lang.Provincial_Health_Coverage_Required || 'Provincial Health Coverage Required' }}
            </div>
            <div class="text-left mx-4 my-4" style="max-height: calc(100vh - 300px); overflow-y: auto;">
              <p>
                {{ lang.We_are_sorry_without_provincial_health_coverage || "We're sorry, without Provincial health coverage we are unable to process your application." }}
                {{ lang.Please_contact_your_administrator_at || 'Please contact your administrator at' }}
                  <strong *ngIf="currFormType == 'nhlaa'">info&#64;scinsurance.ca</strong>
              </p>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 hover:bg-white"
            (click)="closeNoProvincialCoverageModal()">
            {{ lang.Close || 'Close' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(planOptionsModel){
<lib-clinics [optionstitle]="optionstitle" [lang]="lang" [userForm]="userForm"
  [selectedProvinceId]="validationInputData.province_id" [optionmessage]="optionmessage" [_decimalPipe]="_decimalPipe"
  [_CustomDatePipe]="_CustomDatePipe" [(planOptionsModel)]="planOptionsModel"
  [plandetailsobjvalue]="plandetailsobjvalue" (closeClicked)="closeoptionsselection()"
  (confirmClicked)="confirmoptionsselectionV2($event)" [currChild]="currChild" [currChildType]="currChildType" [currChildIndex]="currChildIndex" [planScopeDetails]="planScopeDetails" ></lib-clinics>
}


@if(planOptionsModel && false){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <!-- <div class="text-center font-bold text-2xl">
                {{lang.choose_options}}
              </div> -->
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Choose_Options}}
            </div>
            <div class="mt-3 mx-4 text-left" style="  max-height: calc(100vh - 200px);
        overflow-y: auto;">


              <input type="hidden" id="plandetailsobj" #optionPlanDetailsObj value="{{plandetailsobjvalue}}">
              <input type="hidden" id="optionumber" #optionNumberInput value="{{optionstitle.length}}">


              @for(option of optionstitle; track option;let i = $index){
              <div>
                <h3><b>{{option.name}}</b><span style="color: red">*</span></h3>

                @for(optionvalue of option.planOptionsValues; track optionvalue;let j = $index){
                <div class="row">
                  <div class="col-md-12" style="border: 1px solid black;padding:5px 15px;border-bottom:1px !important">
                    <input type="radio" value="{{optionvalue.json}}"
                      id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" #optionUnseelct
                      class="optionselectionmethod-{{option.id}}"
                      (change)="planoptionselection($event,optionvalue,option.id,optionvalue.id,i,'optionselectionmethod-')">&nbsp;{{optionvalue.name}}

                  </div>
                </div>
                }
                <br>
              </div>
              }
            </div>
          </div>
        </div>
        <div id="planoptionmessage" class="invalid text-red-500"><b>{{optionmessage}}</b></div>

        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="closeoptionsselection()">
            {{lang.Close}}
          </button>&nbsp;
          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-green-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="confirmoptionsselection()">
            {{lang.Confirm}}
            <!-- <strong style="color: white">{{lang.confirm}}</strong> -->
          </button>
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>



<lib-clinics [optionstitle]="optionstitle" [onCloseOptions]="closeoptionsselection"
  [onConfirmOptions]="confirmoptionsselection" [lang]="lang" [optionmessage]="optionmessage"
  [selectedProvinceId]="validationInputData.province_id"></lib-clinics>
}

@if(padAggrementModel){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.PAD_Agreement}}
            </div>
            <div class="text-center">
              <pdf-viewer [src]="generatePADaggrement" style=" height: 60vh;z-index:9999;overflow-y: scroll;"
                class="px-0 w-fill object-cover"></pdf-viewer>

            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700 gap-2">

          @if(signaturestatus){
          <button type="button"
            class="w-44 h-14 mb-1 rounded-full order-first border-2 border-green-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="signaturestartmodel()">
            {{lang.Sign_Agree}}
          </button>
          }
          @if(agreestatus){
          <button type="button"
            class="w-36 h-14 mb-1 order-2 rounded-full border-2 border-green-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="agreepadconditions()">
            {{lang.Agree}}
          </button>
          }
          @if(rejectPADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-3 rounded-full border-2 border-gray-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="rejectPADpafaggrement()">
            {{lang.Reject}}
          </button>
          }

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(padAggrementFinalModel){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.PAD_Agreement}}
            </div>
            <div class="text-center">
              <pdf-viewer [src]="generatePADaggrement" style=" height: 60vh;z-index:9999;overflow-y: scroll;"
                class="px-0 w-fill object-cover"></pdf-viewer>

            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700 gap-2">


          @if(showagree){
          <button type="button"
            class="w-36 h-14 mb-1 order-2 rounded-full border-2 border-green-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="agreepadconditions()">
            {{lang.Agree}}
          </button>
          }
          @if(rejectPADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-3 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="rejectPADpafaggrement1()">
            {{lang.Reject}}
          </button>
          }
          @if(closePADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-4 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="closePADAdggrementModel()">
            {{lang.Close}}
          </button>
          }
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(signModelForBankPay){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-1/4 sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Signature}}
            </div>
            <div class="text-center">

              <div class="signature-container col-span-1 w-full" style="border:1px solid #ccc;border-radius: 4px;">

                <!-- <button class="btn btn-primary btn-inline" (click)="clearPadcc()" [disabled]="signaturecheckvalue1cc">Clear</button> -->

                <!-- <canvas
            #canvascc
            (touchstart)="startDrawingcc($event)"
            (touchmove)="movedcc($event)"
            (click)="signaturestartcc($event)" required
          ></canvas> -->

                <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
                  (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
                  (onBeginEvent)="drawStart()"></signature-pad>
                @if(signaturecheckvalue1cc){
                <div style="
          left: 10px;
          color: red;
          text-decoration: underline;cursor:pointer">
                  <p (click)="clearSignature()">x {{lang.Clear}}</p>
                </div>
                }

              </div>
              @if(showpaderrorMessage){
              <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
              }
              <!-- <div class="mt-2 border-2 border-green-200 rounded-lg w-1/2"> -->


              <!-- <canvas
                  #canvasPadElement
                  (mousedown)="onMouseDownpad($event)" (touchstart)="onMouseDownpad($event)" (touchmove)="onMouseMovepad($event)"
      (mousemove)="onMouseMovepad($event)" required  style="border: 1px solid #ccc;border-radius: 4px;"
                ></canvas>
                @if(signaturecheckvalue1){
                  <div style="
                  left: 10px;
                  color: red;
                  text-decoration: underline;cursor:pointer">
                      <p (click)="clearPadSignature()">x {{lang.clear}}</p>
                  </div>
                }
        @if(signaturemessagepad){
                  <span
                  class="invalid text-red-500"
                  >{{lang.please_sign_the_signature}}</span
                >
        } -->
              <!-- </div> -->


            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
            (click)="savePadsignature()">{{lang.Confirm}}

          </button>

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>


}

@if(imageDisplayShow){
<div class="void-preview-modal" role="dialog" aria-modal="true" aria-labelledby="void-preview-title">
  <!-- Backdrop -->
  <div class="void-preview-backdrop" (click)="closeImagePreview()"></div>
  <!-- Dialog -->
  <div class="void-preview-dialog">
    <!-- Header -->
    <div class="void-preview-header">
      <h3 id="void-preview-title" class="void-preview-title">{{ lang.Preview || 'Document Preview' }}</h3>
      <button type="button" class="void-preview-close" (click)="closeImagePreview()" aria-label="Close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <path d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <!-- Body -->
    <div class="void-preview-body">
      @if(normalview){
      <img [src]="imagedisplay" class="void-preview-img" alt="Void Cheque Preview" />
      }
      @if(pdfview){
      <pdf-viewer [src]="imagedisplay" class="void-preview-pdf"></pdf-viewer>
      }
    </div>
    <!-- Footer -->
    <div class="void-preview-footer">
      <button type="button" class="void-preview-close-btn" (click)="closeImagePreview()">
        {{ lang.Close || 'Close' }}
      </button>
    </div>
  </div>
</div>
}



@if(iafginfo){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg w-full md:w-1/2">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">IAFG Info</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    <form [formGroup]="iafggenderForm">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <div class="sm:col-span-12">
          <label for="" class="">This Form have IAFG Insurance plans, do you wish to continue?<span
              class="text-danger">*</span></label>
          <div class="flex items-center space-x-2">
            <input type="radio" id="memberinfo_true" formControlName="memberinfo" value="true" class="form-radio text-blue-600"
              (change)="memberinfogenderCheck($event)" />
            <label for="memberinfo_true" class="labeling">Yes</label>
          </div>

          <div class="flex items-center space-x-2">
            <input type="radio" id="memberinfo_false" formControlName="memberinfo" value="false" class="form-radio text-blue-600"
              (change)="memberinfogenderCheck($event)" />
            <label for="memberinfo_false" class="labeling">No</label>
          </div>


          @if (IA['memberinfo'].errors && IA['memberinfo'].touched) {
          <div class="invalid text-red-500">
            @if (IA['memberinfo'].errors?.['required']) {
            <div>Please select IAFG GenderAtBirth status</div>
            }
          </div>
          }



        </div>

        @if(iafggenderForm.get('memberinfo')?.value === 'true'){
        <div class="sm:col-span-3">
          <label for="" class="">GenderAtBirth<span class="text-danger">*</span></label>

          <select class="form-control" placeholder="Select" formControlName="gender">

            <option value="" selected disabled>Select</option>

            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>


          @if (IA['gender'].errors && IA['gender'].touched) {
          <div class="invalid text-red-500">
            @if (IA['gender'].errors?.['required']) {
            <div>Please select type</div>
            }
          </div>
          }

        </div>
        }
      </div>
    </form>




    <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
      <button type="button"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
        (click)="hideIAFGgenderfrom()">
        {{ lang.close }}
      </button>
      <button type="submit"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-200 p-0.5  hover:border-green-500"
        [disabled]="iafggenderForm.invalid" (click)="hideIAFGgenderfrom()">
        {{lang.submit}}
      </button>
    </div>

  </div>
</div>
}

@if(benficiary){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
  <div class="bg-white rounded-xl shadow-lg w-full md:w-[77%]  mx-4 my-4">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white rounded-t-xl">
      <h2 class="text-[18px] font-semibold">{{lang.Beneficiary_Information}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    @if(showBenificiaryForm){
    <form [formGroup]="benficiaryForm" style="font-size:14px;">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-4">

        <ng-container *ngFor="let sectionKey of activeBeneficiarySections">
          <ng-container *ngFor="let fieldKey of getBeneficiaryFieldKeys(sectionKey)">
            <ng-container *ngIf="isBeneficiaryFieldVisible(activeBeneficiaryFields[sectionKey][fieldKey])">

              <!-- TEXT -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'text'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (keypress)="alphabatesOnly($event)"
                    (change)="updateBeneficiaryValidators()"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['minlength']">
                      {{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}
                    </div>
                  </div>
                </div>
              </ng-container>

               <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'email'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="email"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (change)="updateBeneficiaryValidators()"
                  />

                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                     <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['pattern']">{{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error1] || activeBeneficiaryFields[sectionKey][fieldKey].error1 }}</div>
                  </div>
                </div>
              </ng-container>

              <!-- DROPDOWN -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'dropdown'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <select
                    class="form-control"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (change)="updateBeneficiaryValidators()"
                  >
                    <option value="" disabled>{{ lang.Select }}</option>
                    <option
                      *ngFor="let opt of activeBeneficiaryFields[sectionKey][fieldKey].options"
                      [value]="opt.value"
                    >
                      {{ lang[opt.label] || opt.label }}
                    </option>
                  </select>
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- RADIO -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'radio'">
                <div class="sm:col-span-3">
                  <label class="labeling lineheight">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <div *ngFor="let opt of activeBeneficiaryFields[sectionKey][fieldKey].options"
                      class="flex items-center space-x-2">
                    <input
                      type="radio"
                      [id]="activeBeneficiaryFields[sectionKey][fieldKey].control_name + '_' + opt.value"
                      [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                      [value]="opt.value"
                      class="form-radio text-blue-600"
                      (change)="updateBeneficiaryValidators()"
                    />
                    <label [for]="activeBeneficiaryFields[sectionKey][fieldKey].control_name + '_' + opt.value" class="labeling">
                      {{ lang[opt.label] || opt.label }}
                    </label>
                  </div>
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- NUMBER -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'number'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (keypress)="numbersOnly($event)"
                    (blur)="fieldKey === 'beneficiary_percentage' ? checkpercentagevalue($event) : null"
                    (input)="fieldKey === 'beneficiary_percentage' ? checkpercentagevalue($event) : null"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>


              <!-- phone -->

               <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'phone'">
                  <div class="sm:col-span-3">
                    <label  class="labeling">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                      <span *ngIf="isRequired(activeBeneficiaryFields[sectionKey][fieldKey])" style="color:red">*</span>
                    </label>
                    <input
                      type="tel"
                      class="form-control checking-field"
                      [id]="activeBeneficiaryFields[sectionKey][fieldKey].field"
                      placeholder="+1 (123) 456-7890"
                      [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                      (change)="phoneFormat($event)"
                    />
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched" class="invalid text-red-500">
                      <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">{{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] }}</div>
                      <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['minlength'] || benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['maxlength']">{{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error1] }}</div>
                    </div>
                  </div>
                </ng-container>

          


              <!-- DATEPICKER -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'datepciker'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    (paste)="(false)"
                    class="form-control"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    [minDate]="minDate"
                    [maxDate]="childmaxDate"
                    #dp
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY', showWeekNumbers: false, containerClass: currFormType === 'nhlaa' ? 'theme-green nhlaa-datepicker' : 'theme-green' }"
                    placeholder="MM-DD-YYYY"
                    bsDatepicker
                    (blur)="onDateBlur(fieldKey, $event)"
                    (bsValueChange)="onDateChange($event)"
                    (input)="onDateBlur(fieldKey, $event)"
                    (keypress)="numbersOnly($event)"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>

      </div>

      <div class="flex justify-end p-2">
        <button type="button"
          class="w-28 h-12 mt-4 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold text-[14px] transition duration-700 ease-in-out hover:bg-white"
          [disabled]="benficiaryForm.invalid"
          (click)="savebenficiary(benficiaryForm.value)">
          Save
        </button>
      </div>
    </form>
    }

    @if(addbenificaryData.length>0){
    <div class="p-4">
      <div class="overflow-x-auto rounded border border-gray-200">
      <table class="w-full text-[14px] text-black border-collapse" id="customerPlansTable">
        <thead class="bg-gray-100">
          <tr>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.First_Name}}</th>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Last_Name}}</th>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Relation}}</th>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Date_of_Birth}}</th>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Gender}}</th>
            <th class="px-3 py-2 text-left font-semibold border border-gray-200 whitespace-nowrap text-[14px]">Trustee Name - Relation</th>
            <th class="px-3 py-2 text-center font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Percentage}}</th>
            <th class="px-3 py-2 text-center font-semibold border border-gray-200 whitespace-nowrap text-[14px]">{{lang.Action}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let broker of addbenificaryData; let i = index"
              class="border-b border-gray-200" [ngClass]="{'bg-gray-50': i % 2 == 0}">
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">{{broker.firstName}}</td>
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">{{broker.lastName}}</td>
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">
              {{broker.relationship?.toLowerCase() === 'other'
                ? capitalizeFirstLetter(broker.relationshipSpecific ?? '')
                : capitalizeFirstLetter(broker.relationship?.replace('_',' ') ?? '')}}
            </td>
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">
              @if(broker.dob==null){ NA }@else{ {{broker.dob | displayDate}} }
            </td>
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">{{broker.gender}}</td>
            <td class="px-3 py-2 border border-gray-200 whitespace-nowrap text-[14px]">
              @if(broker.trusteeFirstName==""){ NA }@else{
                {{broker.trusteeFirstName + ' ' + broker.trusteeLastName + ' - ' + broker.trusteeRelation}}
              }
            </td>
            <td class="px-3 py-2 border border-gray-200 text-center whitespace-nowrap text-[14px]">{{broker.percentage}}%</td>
            <td class="px-3 py-2 border border-gray-200 text-center">
              <div class="flex items-center justify-center gap-1">
                <svg class="h-7 w-7 text-green-600 cursor-pointer" (click)="editbenficiary($event, i, broker)"
                  *ngIf="enableEditIndex != i" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                  <line x1="16" y1="5" x2="19" y2="8" />
                </svg>
                <svg class="h-7 w-7 text-red-600 cursor-pointer" (click)="deleteBenficiary(broker, i)" *ngIf="enableEditIndex != i"
                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <rect x="3" y="4" width="18" height="4" rx="2" />
                  <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                  <line x1="10" y1="12" x2="14" y2="12" />
                </svg>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="mt-4">
        <button type="button"
          class="w-32 h-10 rounded-full border-2 border-indigo-700 bg-gray-100 font-semibold text-[14px] transition hover:bg-white"
          (click)="addnewbenficiary()">
          {{lang.Add_More}}
        </button>
      </div>

    </div>

    <form [formGroup]="wawanessaForm" *ngIf="currFormType != 'viking'">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <div class="sm:col-span-4">
          <label>Do you smoke?</label>
          <div class="flex items-center space-x-2">
            <span class="flex items-center space-x-2">
              <input type="radio" id="smoker_true" formControlName="smoker" value="true" class="form-radio text-blue-600" />
              <label for="smoker_true" class="labeling">{{lang.Yes}}</label>
            </span>

            <span class="flex items-center space-x-2">
              <input type="radio" id="smoker_false" formControlName="smoker" value="false" class="form-radio text-blue-600" />
              <label for="smoker_false" class="labeling">{{lang.No}}</label>
            </span>
          </div>
          @if (w['smoker'].errors && w['smoker'].touched) {
          <div class="invalid text-red-500">
            @if (w['smoker'].errors?.['required']) {
            <div>Please choose smoking information</div>
            }
          </div>
          }
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">Earnings frequency<span class="text-danger">*</span></label>
          <select class="form-control" id="gender" placeholder="Select" formControlName="earningsFrequency">
            <option value="" selected disabled>{{lang.Select}}</option>
            <option *ngFor="let name of wawanesaEarningsFrequencyList" [value]="name.value">
              {{ name.label }}
            </option>
            <!-- <option value="" disabled>{{ lang.Select }}</option>
            <option value="HOURLY">Hourly</option>
            <option value="WEEKLY">Weekly</option>
            <option value="FORTNIGHTLY">Bi-weekly</option>
            <option value="MONTHLY">Monthly</option>
            <option value="YEARLY">Annually</option> -->
          </select>
          @if (w['earningsFrequency'].errors && w['earningsFrequency'].touched) {
          <div class="invalid text-red-500">
            @if (w['earningsFrequency'].errors?.['required']) {
            <div>Please enter Earnings frequency</div>
            }
          </div>
          }
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">Earnings amount<span class="text-danger">*</span></label>
          <input type="number" class="form-control checking-field" placeholder="$" formControlName="earningsAmount"
            (keypress)="decimalNumberOnly($event)" min="1">
          @if (w['earningsAmount'].errors && w['earningsAmount'].touched) {
          <div class="invalid text-red-500">
            @if (w['earningsAmount'].errors?.['required']) {
            <div>Please enter earnings amount</div>
            }
            @if (w['earningsAmount'].errors?.['min']) {
            <div>Earnings must be at least $1.00</div>
            }
          </div>
          }
        </div>
      </div>
    </form>

    <div class="flex justify-end gap-3 border-t border-gray-200 px-4 py-3">
      <button type="button"
        class="w-28 h-10 rounded-full border-2 border-gray-500 bg-gray-100 font-semibold text-[14px] hover:bg-white transition"
        (click)="onClose()">
        {{ lang.Close }}
      </button>
      <button type="submit"
        class="w-28 h-10 rounded-full border-2 border-indigo-700 font-semibold text-[14px] hover:bg-indigo-50 transition"
        (click)="finalbenificiarySubmit()">
        {{lang.Submit}}
      </button>
    </div>
    }


  </div>
</div>
}

@if(addeditbenficiary){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg w-full md:w-[77%]">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[18px] font-semibold">{{BenficairyModalAddAndUpdateButton}} {{lang.Beneficiary_Information}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    <form [formGroup]="benficiaryForm" (ngSubmit)="addeditbenficarySubmit()" style="font-size:14px;">

      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-4">

        <ng-container *ngFor="let sectionKey of activeBeneficiarySections">
          <ng-container *ngFor="let fieldKey of getBeneficiaryFieldKeys(sectionKey)">
            <ng-container *ngIf="isBeneficiaryFieldVisible(activeBeneficiaryFields[sectionKey][fieldKey])">

              <!-- TEXT -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'text'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (keypress)="alphabatesOnly($event)"
                    (change)="updateBeneficiaryValidators()"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['minlength']">
                      {{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- EMAIL -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'email'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="email"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (change)="updateBeneficiaryValidators()"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['pattern']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error1] || activeBeneficiaryFields[sectionKey][fieldKey].error1 }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- DROPDOWN -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'dropdown'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <select
                    class="form-control"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (change)="updateBeneficiaryValidators()"
                  >
                    <option value="" disabled>{{ lang.Select }}</option>
                    <option
                      *ngFor="let opt of activeBeneficiaryFields[sectionKey][fieldKey].options"
                      [value]="opt.value"
                    >
                      {{ lang[opt.label] || opt.label }}
                    </option>
                  </select>
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- RADIO -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'radio'">
                <div class="sm:col-span-3">
                  <label class="labeling lineheight">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <div *ngFor="let opt of activeBeneficiaryFields[sectionKey][fieldKey].options"
                      class="flex items-center space-x-2">
                    <input
                      type="radio"
                      [id]="activeBeneficiaryFields[sectionKey][fieldKey].control_name + '_edit_' + opt.value"
                      [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                      [value]="opt.value"
                      class="form-radio text-blue-600"
                      (change)="updateBeneficiaryValidators()"
                    />
                    <label [for]="activeBeneficiaryFields[sectionKey][fieldKey].control_name + '_edit_' + opt.value" class="labeling">
                      {{ lang[opt.label] || opt.label }}
                    </label>
                  </div>
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- NUMBER -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'number'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control checking-field"
                    [placeholder]="activeBeneficiaryFields[sectionKey][fieldKey].placeholder"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (keypress)="numbersOnly($event)"
                    (blur)="fieldKey === 'beneficiary_percentage' ? checkpercentagevalue($event) : null"
                    (input)="fieldKey === 'beneficiary_percentage' ? checkpercentagevalue($event) : null"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- PHONE -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'phone'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="isRequired(activeBeneficiaryFields[sectionKey][fieldKey])" style="color:red">*</span>
                  </label>
                  <input
                    type="tel"
                    class="form-control checking-field"
                    [id]="activeBeneficiaryFields[sectionKey][fieldKey].field"
                    placeholder="+1 (123) 456-7890"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    (change)="phoneFormat($event)"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched" class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">{{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] }}</div>
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['minlength'] || benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['maxlength']">{{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error1] }}</div>
                  </div>
                </div>
              </ng-container>

              <!-- DATEPICKER -->
              <ng-container *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].type === 'datepciker'">
                <div class="sm:col-span-3">
                  <label class="labeling">
                    {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].language_token] || activeBeneficiaryFields[sectionKey][fieldKey].label }}
                    <span *ngIf="activeBeneficiaryFields[sectionKey][fieldKey].required?.includes(currFormType)" style="color:red">*</span>
                  </label>
                  <input
                    type="text"
                    (paste)="(false)"
                    class="form-control"
                    [formControlName]="activeBeneficiaryFields[sectionKey][fieldKey].control_name"
                    [minDate]="minDate"
                    [maxDate]="childmaxDate"
                    #dp
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY', showWeekNumbers: false, containerClass: currFormType === 'nhlaa' ? 'theme-green nhlaa-datepicker' : 'theme-green' }"
                    placeholder="MM-DD-YYYY"
                    bsDatepicker
                    (blur)="onDateBlur(fieldKey, $event)"
                    (bsValueChange)="onDateChange($event)"
                    (input)="onDateBlur(fieldKey, $event)"
                    (keypress)="numbersOnly($event)"
                  />
                  <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors
                            && benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.touched"
                      class="invalid text-red-500">
                    <div *ngIf="benficiaryForm.get(activeBeneficiaryFields[sectionKey][fieldKey].control_name)?.errors?.['required']">
                      {{ lang[activeBeneficiaryFields[sectionKey][fieldKey].error] || activeBeneficiaryFields[sectionKey][fieldKey].error }}
                    </div>
                  </div>
                </div>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>

      </div>



      <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
        <button type="button"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold text-[14px] hover:bg-white"
          (click)="onCloseaddeditbenificary()">
          {{ lang.Close }}
        </button>
        <button type="submit"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold text-[14px] hover:border-green-500"
          [disabled]="benficiaryForm.invalid">
          Save
        </button>
      </div>
    </form>




  </div>
</div>
}

@if(showMedcanForm){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" style="position: absolute; z-index: 0;">
  <div class="bg-white rounded-xl shadow-lg max-w-2xl w-full mx-4">
    <!-- Header -->
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white rounded-t-xl">
      <h2 class="text-[14px] font-semibold">Plan selection for members</h2>
    </div>

    <!-- Content -->
    <div class="p-6 max-h-[60vh] overflow-y-auto">
      <div class="mb-4 p-4 bg-blue-50 rounded-lg">
         <p class="text-md text-gray-700 mb-2">
          <!-- without tax price single plan need to show -->
          <strong>{{medcanPlanName}}</strong> <span style="margin-left: 130px;">${{ originalMedcanPrice | number:'1.2-2' }}</span> 
        </p>
        <p class="text-xs text-gray-500">Choose members to enroll in this plan</p>
      </div>



      <!-- select doctor gender (optional) -->
       <!-- select clinic (yes or no) --> 
      <!-- Member (Primary) - Always selected and disabled -->
      <div class="mb-4 p-4 bg-gray-100 rounded-lg border-l-4 border-indigo-700">
        <label class="flex items-center cursor-not-allowed">
          <input type="checkbox" [checked]="memberSelected" disabled
            class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 opacity-60" />
          <span class="ml-3 text-gray-900 font-semibold">
            {{ validationInputData.firstName }} {{ validationInputData.lastName }}
            <span class="text-sm text-gray-600 font-normal">(Member - Primary)</span>
          </span>
        </label>

        <div class="ml-8 mt-2">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Doctor's Gender <span class="text-red-500">*</span>
          </label>
          <select
            [(ngModel)]="doctorSelfGender"
            name="doctorSelfGender"
            required
            #doctorSelfGenderRef="ngModel"
            (ngModelChange)="onSelfDoctorGenderChange($event)"
            class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': doctorSelfGenderRef.invalid && doctorSelfGenderRef.touched}"
          >
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="any">Any</option>
          </select>
          <p *ngIf="doctorSelfGenderRef.invalid && doctorSelfGenderRef.touched" class="text-red-500 text-xs mt-1">
            Doctor's Gender is required.
          </p>
        </div>

        <div class="ml-8 mt-2">
         <div *ngIf="planScopeDetails.length==0">
          <button 
            type="button"
            (click)="openClinicModal()"
            class="flex items-center gap-2 px-4 py-2 border-2 border-dashed border-indigo-400 rounded-lg text-indigo-600 font-semibold hover:bg-indigo-50 transition"
          >
            <span class="text-xl">+</span> Add Clinic
          </button>
          <p *ngIf="clinicSubmitAttempted && planScopeDetails.length==0" class="text-red-500 text-xs mt-1">
            Please add a clinic.
          </p>
        </div>

        <!-- Clinic already added -->
        <div *ngIf="planScopeDetails.length>0" class="flex items-center justify-between border border-gray-300 rounded-lg p-3 bg-gray-50">
          <div>
            <p class="text-sm font-semibold text-gray-800">{{ planScopeDetails[0].options[0].clinic ?? planScopeDetails[0].clinicName }}</p>
          </div>
          <button 
            type="button"
            (click)="openClinicModal()"
            class="text-sm text-indigo-600 font-medium hover:underline"
          >
            Update
          </button>
        </div>
      
      </div>



        <!-- <div class="ml-8 mt-2">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Select Clinic <span class="text-red-500">*</span>
          </label>
          <div class="flex items-center gap-6">
            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSelfSelection" value="yes"
                [(ngModel)]="clinicSelfSelection"
                required
                #clinicSelfSelectionRef="ngModel"
                (change)="onClinicChange(true)" class="mr-2" />
              Yes
            </label>
            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSelfSelection" value="no"
                [(ngModel)]="clinicSelfSelection"
                (change)="onClinicChange(true)" class="mr-2" />
              No
            </label>
          </div>
          <p *ngIf="clinicSelfSelectionRef.invalid && clinicSelfSelectionRef.touched" class="text-red-500 text-xs mt-1">
            Please select a clinic option.
          </p>
        </div> -->
      </div>

      <!-- Spouse -->
@if(validationInputData.having_spouse && validationInputData.spouse_details) {
<div class="mb-4 p-4 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
  <label class="flex items-center cursor-pointer">
    <input type="checkbox" [(ngModel)]="spouseSelected"
      (ngModelChange)="onSpouseChange($event, validationInputData.spouse_details)"
      class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer" />
    <span class="ml-3 text-gray-900">
      {{ validationInputData.spouse_details.firstName }} {{ validationInputData.spouse_details.lastName }}
      <span class="text-sm text-gray-600">(Spouse)</span>
    </span>
  </label>
  <div class="ml-8 mt-2 text-xs text-gray-500">
    DOB: {{ validationInputData.spouse_details.dob }} | Gender: {{ validationInputData.spouse_details.gender }}
  </div>

  <div class="ml-8 mt-2" *ngIf="spouseSelected">
    <label class="block text-sm font-medium text-gray-700 mb-2">Doctor's Gender <span class="text-red-500">*</span></label>
    <select
      [(ngModel)]="doctorSpouseGender"
      name="doctorSpouseGender"
      (ngModelChange)="onSpouseDoctorGenderChange($event)"
      class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
    >
      <option value="">Select</option>
      <option value="male">Male</option>
      <option value="female">Female</option>
      <option value="any">Any</option>
    </select>
  </div>

  <div class="ml-8 mt-2" *ngIf="spouseSelected">
    <label class="block text-sm font-medium text-gray-700 mb-2">Select clinic same as member</label>
    <div class="flex items-center gap-6">
      <!-- FIX: unique name "clinicSpouse" to avoid conflict with child radios -->
      <label class="flex items-center cursor-pointer">
        <input type="radio" name="clinicSpouseSelection" value="yes"
          [(ngModel)]="clinicSpouseSelection" (change)="onClinicChange()" class="mr-2" />
        Yes
      </label>
      <label class="flex items-center cursor-pointer">
        <input type="radio" name="clinicSpouseSelection" value="no"
          [(ngModel)]="clinicSpouseSelection" (change)="onClinicChange()" class="mr-2" />
        No
      </label>
    </div>
  </div>
</div>
}

<!-- Children -->
@if(validationInputData.having_dependent_children && validationInputData.children_details?.length > 0) {
<div class="space-y-3">
  @for(child of validationInputData.children_details; track $index) {
  <div class="mb-4 p-4 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
    <label class="flex items-center cursor-pointer">
      <input type="checkbox" [(ngModel)]="childrenSelected[$index]"
        (ngModelChange)="onChildChange($event, $index, child)"
        class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer" />
      <span class="ml-3 text-gray-900">
        {{ child.firstName }} {{ child.lastName }}
        <span class="text-sm text-gray-600">(Child {{ $index + 1 }})</span>
      </span>
    </label>
    <div class="ml-8 mt-2 text-xs text-gray-500">
      DOB: {{ child.dob }} | Gender: {{ child.gender }}
    </div>

    <div class="ml-8 mt-2" *ngIf="childrenSelected[$index]">
      <label class="block text-sm font-medium text-gray-700 mb-2">Doctor's Gender <span class="text-red-500">*</span></label>
      <select
        [(ngModel)]="doctorGender[$index]"
        [name]="'doctorGender' + $index"
        (ngModelChange)="onChildDoctorChange($event, $index, child)"
        class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
      >
        <option value="">Select</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="any">Any</option>
      </select>
    </div>

    <div class="ml-8 mt-2" *ngIf="childrenSelected[$index]">
      <label class="block text-sm font-medium text-gray-700 mb-2">Select clinic same as member</label>
      <div class="flex items-center gap-6">
        <!-- FIX: unique name per child using $index to avoid radio conflicts -->
        <label class="flex items-center cursor-pointer">
          <input type="radio" [name]="'clinicChild' + $index" value="yes"
            [(ngModel)]="clinicSelection[$index]"
            (change)="onClinicChildChange($index)" class="mr-2" />
          Yes
        </label>
        <label class="flex items-center cursor-pointer">
          <input type="radio" [name]="'clinicChild' + $index" value="no"
            [(ngModel)]="clinicSelection[$index]"
            (change)="onClinicChildChange($index)" class="mr-2" />
          No
        </label>

      </div>
    </div>
  </div>
  }
</div>
}

      <!-- No dependents message -->
      @if(!validationInputData.having_spouse && !validationInputData.having_dependent_children) {
      <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p class="text-sm text-yellow-800">No dependents available</p>
      </div>
      }


      <div style="display: inline-block; min-width: 100%;">
        <table style="width: 100%; font-size: 14px; border-collapse: collapse; border: 1px solid #000;">
          <thead>
            <tr>
              <th style="color: black; background-color: #d9d9ea; font-style: italic; padding: 8px 12px; font-weight: 500; text-align: left; border: 1px solid #000;">Members selected</th>
              <th style="color: black; background-color: #d9d9ea; font-style: italic; padding: 8px 12px; font-weight: 500; text-align: left; border: 1px solid #000;">Total premium price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: center; padding: 8px 12px; font-weight: 500; border: 1px solid #000;">{{ selectedCount }}</td>
              <td style="text-align: right; padding: 8px 12px; font-weight: 500; border: 1px solid #000;">${{ (planAmount * selectedCount).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>


         <p class="text-sm text-gray-500 p-4" style="margin-top: -10px;">Note: The plan price ${{planAmount}} (included tax) will be multiplied based on selected family members.
You will see a summary after confirming.</p>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-2 border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-xl">
      <button type="button"
        class="w-36 h-12 rounded-full border-2 border-gray-700 bg-gray-200 font-bold hover:bg-white transition-colors"
        (click)="onCloseMedcan()">
        {{ lang.Close }}
      </button>
      <button type="button"
        class="w-36 h-12 rounded-full border-2 border-indigo-700 bg-indigo-700 text-white font-bold hover:bg-indigo-800 transition-colors"
        (click)="onSubmitMedcan()">
        {{ lang.Submit }}
      </button>
    </div>
  </div>
</div>
}

@if(benficiaryCount){
<div class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur confirm-dialog ">
  <div class="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
    <div class=" opacity-25 w-full h-full absolute z-10 inset-0"></div>
    <div
      class="bg-white rounded-[14px] border border-gray-400 md:max-w-max md:mx-auto p-4 fixed inset-x-0 bottom-0 z-50 mb-4 mx-4 md:relative shadow-lg">
      <div class="md:flex items-center">
        <div
          class="rounded-full border border-gray-300 flex items-center justify-center w-20 h-16 flex-shrink-0 mx-auto">
          <i class="bx bx-error text-3xl">
            &#9888;
          </i>
        </div>
        <div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
          <p class="font-bold text-[16px]">{{lang.Error}}!</p>
          <p class="text-[16px] text-gray-700 mt-1">{{benficiaryCountMessage}}.
          </p>
        </div>
      </div>
      <div class="text-center md:text-right mt-4 md:flex md:justify-end gap-2">
        <button id="confirm-delete-btn"
          class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 border border-red-500  rounded-full font-semibold text-[14px] md:ml-2 md:order-1"
          (click)="benficiaryconfirm()">
          {{lang.Ok??'Ok'}}
        </button>&nbsp;
        <!-- <button id="confirm-cancel-btn" class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 border border-gray-400 rounded-full font-semibold text-[14px] mt-4 md:mt-0 md:order-2" (click)="benficiaryconfirm()">
                      Cancel
                      </button> -->
      </div>
    </div>
  </div>
</div>
}

@if(showSpouseSignature){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-1/4 sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Spouse_Signature}}
            </div>
            <div class="text-center">

              <div class="signature-container col-span-1 w-full" style="border:1px solid #ccc;border-radius: 4px;">



                <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
                  (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
                  (onBeginEvent)="drawStart()"></signature-pad>
                @if(signaturecheckvalue1cc){
                <div style="
            left: 10px;
            color: red;
            text-decoration: underline;cursor:pointer">
                  <p (click)="clearSignature()">x {{lang.Clear}}</p>
                </div>
                }

              </div>
              @if(showIAFGerrorMessage){
              <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
              }



            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="saveIAFGsignature()">{{lang.Confirm}}

          </button>

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
              <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>


}


@if(ConfirmModel){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg  md:w-1/2 overflow-scroll">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">{{lang.Info}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>
    <p class="p-8"><strong>{{lang.Important_Limitation_applies_for_the_first_24_months_of_this_coverage}}:</strong></p>
    <ul class="p-8" style="list-style: disc !important">
      @if(criticalplancheck){
      <p class="font-bold">{{lang.Life_Insurance}}:</p>
      <li>
        {{lang.If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability_Death_from_suicide_within_24_months_of_the_effective_date_of_an_insured_person_s_coverage_is_excluded}}
      </li>
      <li>{{lang.Death_from_suicide_within_24_months_of_the_effective_date_of_an_insured_person_s_coverage_is_excluded}}
      </li>
      }
      @if(criticalplancheck){
      <p class="font-bold">{{lang.Critical_Illness_Insurance}}:</p>
      <li>
        {{lang.Pre_existing_Condition_Exclusion_applies_for_the_first_24_months_of_this_coverage_Any_symptom_condition_disorder_illness_pre_disease_or_disease_or_any_mental_nervous_or_psychiatric_condition_or_disorder_for_which_any_one_of_medical_advice_treatment_service_prescribed_medication_diagnosis_or_consultation_including_consultation_to_investigate_and_or_diagnose_where_diagnosis_has_not_yet_been_made_was_received_by_the_insured_or_would_have_been_received_by_a_prudent_individual_within_the_24_months_immediately_preceding_the_effective_date}}
      </li>
      <li>
        {{lang.This_pre_existing_condition_exclusion_is_removed_if_the_insured_Employee_subsequently_applies_and_is_approved_for_additional_critical_illness_coverage_requiring_evidence_of_insurability}}
      </li>
      }
    </ul>
    <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


      <button type="button"
        class="w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5  hover:bg-white"
        (click)="closeConfirmModel()">{{lang.Confirm}}

      </button>
    </div>
  </div>
</div>


}
